
import { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { generateToken, TOKEN_HEADER } from '../utils/tokenUtils';
import { API_ENDPOINTS } from '../config/constants';
import '../styles/admin.css';
import '../styles/events.css';
import Quizzes from './admin/Quizzes';
import EventForm from './admin/events/EventForm';
import EventsList from './admin/events/EventsList';
import EventRegistrations from './admin/EventRegistrations';
import MeetupGroup from './admin/MeetupGroup';
import MeetupEvents from './admin/MeetupEvents';
import MeetupAttendees from './admin/MeetupAttendees';
import Ratings from './admin/Ratings';
import EventNotifications from './admin/EventNotifications';
import SurveysList from './admin/surveys/SurveysList';
import SurveyForm from './admin/surveys/SurveyForm';
import './admin/surveys/Surveys.css';

const EMAIL_CONFIG = {
  copilot_training: [
    { level: 1, subject: "Welcome to GitHub Copilot Training!", template: "copilot_welcome" },
    { level: 2, subject: "Your GitHub Copilot Training Details", template: "copilot_details_sent" },
    { level: 3, subject: "Don't Miss Out - Limited Seats Available", template: "copilot_followup_1" },
    { level: 4, subject: "Special Offer: Early Bird Discount", template: "copilot_followup_2" },
    { level: 5, subject: "Last Chance - Training Starts Soon", template: "copilot_final_followup" }
  ],
  training_info: [
    { level: 1, subject: "Welcome - Training Information", template: "copilot_welcome" },
    { level: 2, subject: "Follow-up 1", template: "copilot_followup_1" },
    { level: 3, subject: "Follow-up 2", template: "copilot_followup_2" },
    { level: 4, subject: "Final Follow-up", template: "copilot_final_followup" }
  ],
  architect_program: [
    { level: 1, subject: "Welcome to Architect Program", template: "copilot_welcome" },
    { level: 2, subject: "Follow-up 1", template: "copilot_followup_1" },
    { level: 3, subject: "Follow-up 2", template: "copilot_followup_2" },
    { level: 4, subject: "Final Follow-up", template: "copilot_final_followup" }
  ]
};

const MOCK_MARKETING_INSIGHTS_RESPONSE = {
  Summary: "Profile: Chaitanya Allidona (contact: chaitanya.allidona@outlook.com). Highly active Microsoft learner: 278 modules completed, 62 learning paths, 7 active certifications, ~218 hours training. Recent/active certifications and exams include Microsoft Certified: Azure Administrator Associate (earned Jan 16, 2023), Azure Solutions Architect Expert (Jun 24, 2023), GitHub Copilot (Jul 6, 2025), Azure AI Engineer Associate (Jul 10, 2024), Fabric Analytics Engineer Associate (Jul 14, 2024), Microsoft Certified: AI Business Professional (May 9, 2026). Learning activity clusters: Azure architecture and cloud adoption, Azure AI and OpenAI, Microsoft 365 Copilot plus Copilot agents, GitHub Copilot and developer tooling, Microsoft Fabric and Synapse analytics, Cognitive Services (vision, language, search), Power Platform (Power Automate, Power Apps). Engagement signals: recent completion dates across May-Jul 2026 and 2025 show ongoing upskilling (high recency for AI/Copilot topics). Confidence level: High.",
  ChannelInsights: "Primary channels: 1) LinkedIn (professional outreach + short DM) - effective for technical leaders/architects and for sharing case studies. 2) Email (personalized technical invite to webinars/workshops) - contact available. 3) Developer channels (GitHub sponsors, Twitter/X, Discord developer communities) - good for Copilot/GitHub tooling materials. 4) Microsoft Learn / Microsoft community events and Meetup messages - appeals to training-first behavior. Tone: technical, concise, value-focused; include concrete learning outcomes, hands-on labs, certification or credits. Messaging hooks that will resonate: hands-on Copilot + Fabric workshop, Azure AI to business ROI, architect-level design patterns for cloud adoption, accelerate developer productivity with GitHub Copilot + Azure OpenAI. Preferred CTA types: register for a small hands-on workshop, book a 20-min technical consult, download an architecture playbook. Timing and cadence: send initial email/LinkedIn message 2-3 weeks before event, reminder 7 days before, final reminder 24-48 hours prior. Offer a follow-up with on-demand recording and a short next-step lab. Avoid generic marketing; show technical content and certification alignment.",
  MarketingEmail: [
    {
      Subject: "Practical workshop: Build a production Copilot + Azure OpenAI workflow (hands-on)",
      Body: "Hi Chaitanya - I saw your recent Microsoft AI and GitHub Copilot learning activity and wanted to invite you to an exclusive hands-on workshop where we'll build an end-to-end Copilot + Azure OpenAI workflow, deployable patterns for Microsoft Fabric analytics, and a short checklist for enterprise governance and cost control. This is a technical session with labs and code samples - perfect if you're exploring production AI or preparing teams for deployment.",
      CTA: "Reserve your seat (limited to 20 engineers) - includes lab environment and certificate of attendance.",
      Level: 1
    },
    {
      Subject: "Architect briefing: Scaling Azure AI and Fabric for analytics-driven business outcomes",
      Body: "Hi Chaitanya - with your Azure Architect and Fabric learning history, you may find value in a short 45-minute architect briefing we're running. We'll cover proven design patterns for Fabric + Synapse at scale, integrating Azure AI models while keeping governance and cost controls in place, and a checklist to help you translate PoCs into production safely.",
      CTA: "Book a 45-minute briefing (slots limited) or request the one-page architecture playbook.",
      Level: 2
    },
    {
      Subject: "Developer boost: Save engineering time with GitHub Copilot + best practices",
      Body: "Hi Chaitanya - based on your GitHub Copilot activity, join our 60-minute technical session focused on real GitHub Copilot workflows, prompt engineering basics, and unit-test generation patterns that cut developer time. We'll demo IDE setups, prompt templates that work in enterprise repos, and quick tips to improve code review quality.",
      CTA: "Register now for the developer session - includes sample prompts and a GitHub repo with examples.",
      Level: 3
    }
  ]
};

function Admin() {
    // --- JOBS SECTION STATE ---
    const [jobs, setJobs] = useState([]);
  const [jobApplications, setJobApplications] = useState([]);
    const todayStr = new Date().toISOString().slice(0, 10);
    const [jobFormData, setJobFormData] = useState({
      title: '',
      description: '',
      company: '',
      location: '',
      primaryskills: '',
      secondskills: '',
      createdon: todayStr,
      applyby: '',
      isactive: true
    });
    const [jobImporting, setJobImporting] = useState(false);
    const [jobCSVError, setJobCSVError] = useState('');
    const [jobEditId, setJobEditId] = useState(null);

    // Fetch jobs
    const fetchJobs = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_ENDPOINTS.BASE_URL}/lwt/jobs`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            [TOKEN_HEADER]: generateToken(),
          },
        });
        const data = await response.json();
        setJobs(data);
//         if (!response.ok) throw new Error('Failed to fetch jobs');
//         const data = await response.json();
//         console.log('Fetched jobs data:', data);
//         
//         if (
//           data  
          
//         ) {
         
//         } else {
//           setJobs([
//     {
//         "id": 1,
//         "title": "test1",
//         "description": "test",
//         "company": "test",
//         "location": "test",
//         "primaryskills": "test",
//         "secondskills": "test",
//         "createdon": "2026-05-31T00:00:00.000Z",
//         "applyby": "2026-05-31T00:00:00.000Z",
//         "isactive": true
//     } 
    
// ]);
//         }
      } catch (err) {
        setJobs([
    {
        "id": 2,
        "title": "test2",
        "description": "test",
        "company": "test",
        "location": "test",
        "primaryskills": "test",
        "secondskills": "test",
        "createdon": "2026-05-31T00:00:00.000Z",
        "applyby": "2026-05-31T00:00:00.000Z",
        "isactive": true
    } 
]);
        setError(null);
      } finally {
        setLoading(false);
      }
    };

    const fetchJobApplications = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_ENDPOINTS.BASE_URL}/jobs/apply`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            [TOKEN_HEADER]: generateToken(),
          },
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.error || 'Failed to fetch job applications');
        }

        setJobApplications(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Error fetching job applications:', err);
        setJobApplications([]);
        setError(null);
      } finally {
        setLoading(false);
      }
    };

    // Add or update job
    const handleJobFormSubmit = async (e) => {
      e.preventDefault();
      setActionLoading('job-form');
      try {
        const method = jobEditId ? 'PUT' : 'POST';
        const url = jobEditId
          ? `${API_ENDPOINTS.BASE_URL}/lwt/jobs/${jobEditId}`
          : `${API_ENDPOINTS.BASE_URL}/lwt/jobs`;
        const response = await fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json', [TOKEN_HEADER]: generateToken() },
          body: JSON.stringify(jobFormData)
        });
        const data = await response.json();
        if (response.ok && data.success) {
          alert(`Job ${jobEditId ? 'updated' : 'created'} successfully!`);
          setJobFormData({ title: '', description: '', company: '', location: '', primaryskills: '', secondskills: '', createdon: '', applyby: '', isactive: true });
          setJobEditId(null);
          fetchJobs();
        } else {
          throw new Error(data.message || 'Failed to save job');
        }
      } catch (err) {
        alert('Error: ' + err.message);
      } finally {
        setActionLoading(null);
      }
    };

    // Edit job
    const handleEditJob = (job) => {
      setJobEditId(job.id);
      setJobFormData({
        title: job.title || '',
        description: job.description || '',
        company: job.company || '',
        location: job.location || '',
        primaryskills: job.primaryskills || '',
        secondskills: job.secondskills || '',
        createdon: job.createdon || '',
        applyby: job.applyby || '',
        isactive: job.isactive !== false
      });
    };

    // Activate/deactivate job
    const handleToggleJobActive = async (job) => {
      setActionLoading('toggle-job-' + job.id);
      try {
        let response, data;
        if (job.isactive) {
          // Deactivate: use DELETE
          response = await fetch(`${API_ENDPOINTS.BASE_URL}/lwt/jobs/${job.id}`, {
            method: 'DELETE',
            headers: { [TOKEN_HEADER]: generateToken() }
          });
        } else {
          // Activate: use PUT (or adjust as needed)
          response = await fetch(`${API_ENDPOINTS.BASE_URL}/lwt/jobs/${job.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', [TOKEN_HEADER]: generateToken() },
            body: JSON.stringify({ ...job, isactive: true })
          });
        }
        data = await response.json();
        if (response.ok && data.success) {
          fetchJobs();
        } else {
          throw new Error(data.message || 'Failed to update job');
        }
      } catch (err) {
        alert('Error: ' + err.message);
      } finally {
        setActionLoading(null);
      }
    };

    // Jobs section UI
    const renderJobsSection = () => (
      <div className="section-content">
        <div className="section-header">
          <h2>Jobs Management</h2>
          <div className="section-actions">
            <label className="action-btn action-btn-secondary">
              📥 Import CSV
              <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style={{ display: 'none' }} onChange={handleJobCSVImport} disabled={jobImporting} />
            </label>
            <button className="action-btn action-btn-secondary" onClick={fetchJobs}>🔄 Refresh</button>
          </div>
        </div>
        <form className="job-form" onSubmit={handleJobFormSubmit} style={{ marginBottom: 24, background: '#f9f9f9', padding: 24, borderRadius: 12, boxShadow: '0 2px 8px #eee' }}>
          <h3 style={{ marginBottom: 20, fontWeight: 700, fontSize: 22 }}>{jobEditId ? 'Edit Job' : 'Add New Job'}</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
            <input required placeholder="Title" value={jobFormData.title} onChange={e => setJobFormData(f => ({ ...f, title: e.target.value }))}
              style={{ flex: '1 1 220px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16, marginBottom: 8 }} />
            <input required placeholder="Company" value={jobFormData.company} onChange={e => setJobFormData(f => ({ ...f, company: e.target.value }))}
              style={{ flex: '1 1 220px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16, marginBottom: 8 }} />
            <input placeholder="Location" value={jobFormData.location} onChange={e => setJobFormData(f => ({ ...f, location: e.target.value }))}
              style={{ flex: '1 1 180px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16, marginBottom: 8 }} />
            <input placeholder="Primary Skills" value={jobFormData.primaryskills} onChange={e => setJobFormData(f => ({ ...f, primaryskills: e.target.value }))}
              style={{ flex: '1 1 180px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16, marginBottom: 8 }} />
            <input placeholder="Secondary Skills" value={jobFormData.secondskills} onChange={e => setJobFormData(f => ({ ...f, secondskills: e.target.value }))}
              style={{ flex: '1 1 180px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16, marginBottom: 8 }} />
            <input 
              type="date"
              placeholder="Apply By"
              value={jobFormData.applyby}
              onChange={e => setJobFormData(f => ({ ...f, applyby: e.target.value }))}
              style={{ flex: '1 1 180px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16, marginBottom: 8 }}
            />
          </div>
          <textarea placeholder="Description" value={jobFormData.description} onChange={e => setJobFormData(f => ({ ...f, description: e.target.value }))}
            style={{ width: '100%', marginTop: 8, padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16, minHeight: 80 }} />
          <div style={{ marginTop: 16, display: 'flex', gap: 12, alignItems: 'center' }}>
            <button className="action-btn" type="submit" disabled={actionLoading === 'job-form'}
              style={{ background: '#e53935', color: '#fff', fontWeight: 700, fontSize: 18, padding: '12px 32px', borderRadius: 8, border: 'none', boxShadow: '0 2px 8px #fbb', cursor: 'pointer', transition: 'background 0.2s' }}>
              {jobEditId ? 'Update Job' : 'Add Job'}
            </button>
            {jobEditId && <button className="action-btn action-btn-secondary" type="button" onClick={() => { setJobEditId(null); setJobFormData({ title: '', description: '', company: '', location: '', primaryskills: '', secondskills: '', createdon: todayStr, applyby: '', isactive: true }); }}>Cancel</button>}
          </div>
        </form>
        {jobCSVError && <div style={{ color: 'red', marginBottom: 8 }}>{jobCSVError}</div>}
        {/* Debug: Show jobs array as JSON */}
        
        <div style={{ overflowX: 'auto' }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Company</th>
                <th>Location</th>
                <th>Primary Skills</th>
                <th>Secondary Skills</th>
                <th>Apply By</th>
                <th>Active</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="8">Loading...</td></tr>
              ) : jobs.length === 0 ? (
                <tr><td colSpan="8">No jobs found.</td></tr>
              ) : jobs.map(job => (
                <tr key={job.id} style={job.isactive ? {} : { opacity: 0.5 }}>
                  <td>{job.title}</td>
                  <td>{job.company}</td>
                  <td>{job.location}</td>
                  <td>{job.primaryskills}</td>
                  <td>{job.secondskills}</td>
                  <td>{job.applyby}</td>
                  <td>{job.isactive ? 'Yes' : 'No'}</td>
                  <td>
                    <button className="action-btn action-btn-secondary" onClick={() => handleToggleJobActive(job)} disabled={actionLoading === 'toggle-job-' + job.id}>{job.isactive ? 'Deactivate' : 'Activate'}</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );

    const renderJobApplicationsSection = () => (
      <div className="section-content">
        <div className="section-header">
          <h2>Job Applications</h2>
          <div className="section-actions">
            <button className="action-btn action-btn-secondary" onClick={fetchJobApplications}>🔄 Refresh</button>
          </div>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Job ID</th>
                <th>Role Name</th>
                <th>Name</th>
                <th>Email</th>
                <th>Resume</th>
                <th>Created On</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="8">Loading...</td></tr>
              ) : jobApplications.length === 0 ? (
                <tr><td colSpan="8">No job applications found.</td></tr>
              ) : jobApplications.map((application) => (
                <tr key={application.id} style={application.isactive ? {} : { opacity: 0.5 }}>
                  <td>{application.id}</td>
                  <td>{application.jobid}</td>
                  <td>{application.rolename}</td>
                  <td>{application.name}</td>
                  <td>{application.email}</td>
                  <td>
                    {application.resumeurl ? (
                      <a
                        href={application.resumeurl}
                        target="_blank"
                        rel="noreferrer"
                        className="action-btn action-btn-secondary"
                        style={{ padding: '6px 10px', fontSize: '12px' }}
                      >
                        View Resume
                      </a>
                    ) : 'N/A'}
                  </td>
                  <td>{formatDate(application.createdon)}</td>
                  <td>{application.isactive ? 'Yes' : 'No'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );

    const renderFeedbacksSection = () => (
      <div className="section-content">
        <div className="section-header">
          <h2>Feedbacks</h2>
          <div className="section-actions">
            <button className="action-btn action-btn-secondary" onClick={fetchFeedbacks}>🔄 Refresh</button>
          </div>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Event</th>
                <th>Participant</th>
                <th>Email</th>
                <th>Overall</th>
                <th>Session Speed</th>
                <th>Content</th>
                <th>Trainer</th>
                <th>Comments</th>
                <th>Approved</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="12">Loading...</td></tr>
              ) : feedbacks.length === 0 ? (
                <tr><td colSpan="12">No feedback entries found.</td></tr>
              ) : feedbacks.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.event_name || 'N/A'}</td>
                  <td>{item.participant_name || 'N/A'}</td>
                  <td>{item.participant_email || 'N/A'}</td>
                  <td>{item.overall_rating ?? 'N/A'}</td>
                  <td>{item.session_speed_rating ?? 'N/A'}</td>
                  <td>{item.content_quality_rating ?? 'N/A'}</td>
                  <td>{item.trainer_rating ?? 'N/A'}</td>
                  <td style={{ maxWidth: '240px', whiteSpace: 'pre-wrap' }}>{item.comments || 'N/A'}</td>
                  <td>{item.approved ? 'Yes' : 'No'}</td>
                  <td>{formatDate(item.created_at)}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button
                        className="action-btn action-btn-secondary"
                        disabled={actionLoading === `feedback-${item.id}` || item.approved === true}
                        onClick={() => handleFeedbackApproval(item.id, true)}
                      >
                        Approve
                      </button>
                      <button
                        className="action-btn action-btn-secondary"
                        disabled={actionLoading === `feedback-${item.id}` || item.approved === false}
                        onClick={() => handleFeedbackApproval(item.id, false)}
                      >
                        Disapprove
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  const [activeSection, setActiveSection] = useState('dashboard');
  const [leads, setLeads] = useState([]);
  const [courses, setCourses] = useState([]);
  const [users, setUsers] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copiedLeadId, setCopiedLeadId] = useState(null);
  const [dashboardStats, setDashboardStats] = useState(null);

  // ─── Surveys state ────────────────────────────────────────────────────
  const [surveys, setSurveys] = useState([]);
  const [surveysLoading, setSurveysLoading] = useState(false);
  const [surveysPage, setSurveysPage] = useState(1);
  const [surveysPagination, setSurveysPagination] = useState(null);
  const [surveysStatusFilter, setSurveysStatusFilter] = useState('');
  const [showSurveyModal, setShowSurveyModal] = useState(false);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [surveySubmitting, setSurveySubmitting] = useState(false);
  const [surveyActionLoading, setSurveyActionLoading] = useState(null);

  // Hash lead ID for feedback URL (client-side hashing using btoa)
  const hashLeadId = (leadId) => {
    try {
      // Simple encryption using btoa (base64) and character shifting
      const str = leadId.toString();
      const encoded = btoa(str);
      return encoded.split('').map(char => 
        String.fromCharCode(char.charCodeAt(0) + 3)
      ).join('');
    } catch (error) {
      console.error('Error hashing lead ID:', error);
      return null;
    }
  };

  // Generate feedback URL
  const generateFeedbackUrl = (leadId) => {
    const hashedId = hashLeadId(leadId);
    if (!hashedId) return null;
    const baseUrl = window.location.origin;
    return `${baseUrl}/feedback?leadid=${encodeURIComponent(hashedId)}`;
  };

  // Handle Request Feedback action
  const handleRequestFeedback = (lead) => {
    const feedbackUrl = generateFeedbackUrl(lead.id);
    if (feedbackUrl) {
      navigator.clipboard.writeText(feedbackUrl).then(() => {
        setCopiedLeadId(lead.id);
        alert(`Feedback URL copied to clipboard!\n\nYou can share this with ${lead.name}:\n${feedbackUrl}`);
        setTimeout(() => setCopiedLeadId(null), 3000);
      }).catch(err => {
        console.error('Failed to copy:', err);
        prompt('Copy this feedback URL:', feedbackUrl);
      });
    } else {
      alert('Failed to generate feedback URL');
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState('');
  const [filterInterestedIn, setFilterInterestedIn] = useState('All');
  const [showOnlyDuplicates, setShowOnlyDuplicates] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [newStatus, setNewStatus] = useState('');
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showNewLeadModal, setShowNewLeadModal] = useState(false);
  const [showInsightsModal, setShowInsightsModal] = useState(false);
  const [insightsLead, setInsightsLead] = useState(null);
  const [insightsPayload, setInsightsPayload] = useState(null);
  const [editableInsightsEmails, setEditableInsightsEmails] = useState([]);
  const [insightEmailSendingLevel, setInsightEmailSendingLevel] = useState(null);
  const [newLeadSubmitting, setNewLeadSubmitting] = useState(false);
  const [newLeadError, setNewLeadError] = useState('');
  const [newLeadProfilePdf, setNewLeadProfilePdf] = useState(null);
  const [newLeadUpcomingEvents, setNewLeadUpcomingEvents] = useState([]);
  const [newLeadEventsLoading, setNewLeadEventsLoading] = useState(false);
  const [newLeadFormData, setNewLeadFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    consent: false,
    interestedIn: 'copilot_training',
    status: 'New'
  });
  const [emailLevel, setEmailLevel] = useState('copilot_welcome');
  const [seriesFilter, setSeriesFilter] = useState('All');
  const [sourceFilter, setSourceFilter] = useState('All');
  const [interestedInFilter, setInterestedInFilter] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [showCourseModal, setShowCourseModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingCourseId, setEditingCourseId] = useState(null);
  const [showModulesModal, setShowModulesModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [uploadedModules, setUploadedModules] = useState([]);
  const [xlsxFile, setXlsxFile] = useState(null);
  const [existingModules, setExistingModules] = useState([]);
  const [loadingModules, setLoadingModules] = useState(false);
  const [expandedModules, setExpandedModules] = useState(new Set());
  const [moduleLessons, setModuleLessons] = useState({});
  const [loadingLessons, setLoadingLessons] = useState({});
  const [showEnrollmentModal, setShowEnrollmentModal] = useState(false);
  const [enrollmentFormData, setEnrollmentFormData] = useState({
    user_id: '',
    course_id: '',
    enrollment_source: 'direct',
    status: 'active',
    payment_status: 'pending',
    payment_amount: 0,
    notes: ''
  });
  const [userSearchQuery, setUserSearchQuery] = useState('');
  const [courseSearchQuery, setCourseSearchQuery] = useState('');
  const [userSearchResults, setUserSearchResults] = useState([]);
  const [courseSearchResults, setCourseSearchResults] = useState([]);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showCourseDropdown, setShowCourseDropdown] = useState(false);
  const [selectedUserName, setSelectedUserName] = useState('');
  const [selectedCourseName, setSelectedCourseName] = useState('');
  const [courseViewMode, setCourseViewMode] = useState('list'); // 'list' or 'grid'
  const [courseFormData, setCourseFormData] = useState({
    course_code: '',
    title: '',
    slug: '',
    short_description: '',
    description: '',
    thumbnail_url: '',
    preview_video_url: '',
    category: '',
    level: 'beginner',
    language: 'English',
    duration_hours: 0,
    instructor_id: '',
    price_usd: 0,
    price_inr: 0,
    price_aud: 0,
    is_published: false,
    is_featured: false,
    enrollment_limit: 0,
    prerequisites: '',
    learning_outcomes: '',
    target_audience: '',
    certificate_available: true
  });
  
  // Event Management States
  const [events, setEvents] = useState([]);
  const [eventCategories, setEventCategories] = useState([]);
  const [showEventModal, setShowEventModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventViewMode, setEventViewMode] = useState('list'); // 'list' or 'grid'
  const [eventFilters, setEventFilters] = useState({
    status: '',
    location_type: '',
    category_id: '',
    upcoming_only: false,
    featured_only: false
  });
  const [editingEventId, setEditingEventId] = useState(null);
  
  // Invite Modal States
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [inviteEvent, setInviteEvent] = useState(null);
  const [inviteRegistrations, setInviteRegistrations] = useState([]);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [inviteSearch, setInviteSearch] = useState('');
  const [selectedInvitees, setSelectedInvitees] = useState(new Set());

  // Event Categories Management States
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isEditingCategory, setIsEditingCategory] = useState(false);
  const [categoryFormData, setCategoryFormData] = useState({
    name: '',
    slug: '',
    description: '',
    color: '#3B82F6',
    icon: '',
    is_active: true
  });

  // Past Event Images Management States
  const [pastEventImages, setPastEventImages] = useState([]);
  const [pastEventImagesLoading, setPastEventImagesLoading] = useState(false);
  const [pastEventImageUploading, setPastEventImageUploading] = useState(false);
  const [pastEventImageEvents, setPastEventImageEvents] = useState([]);
  const [pastEventImageEventsLoading, setPastEventImageEventsLoading] = useState(false);
  const [pastEventImageFormData, setPastEventImageFormData] = useState({
    event_id: '',
    title: '',
    event_date: '',
    alt_text: '',
    tags: ''
  });
  const [pastEventImageFile, setPastEventImageFile] = useState(null);
  
  const itemsPerPage = 15;

  useEffect(() => {
    const authStatus = sessionStorage.getItem('adminAuth');
    const loginTimestamp = sessionStorage.getItem('adminLoginTime');
    
    if (authStatus === 'true' && loginTimestamp) {
      const currentTime = Date.now();
      const timeDiff = currentTime - parseInt(loginTimestamp, 10);
      const eightHoursInMs = 8 * 60 * 60 * 1000; // 8 hours in milliseconds
      
      if (timeDiff < eightHoursInMs) {
        setIsAuthenticated(true);
        fetchLeads();
      } else {
        // Session expired
        sessionStorage.removeItem('adminAuth');
        sessionStorage.removeItem('adminLoginTime');
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      fetchDashboardStats();
      if (activeSection === 'leads') {
        fetchLeads();
      } else if (activeSection === 'courses') {
        fetchCourses();
      } else if (activeSection === 'users') {
        fetchUsers();
      } else if (activeSection === 'enrollments') {
        fetchEnrollments();
      } else if (activeSection === 'events') {
        fetchEvents();
        fetchEventCategories();
      } else if (activeSection === 'eventCategories') {
        fetchEventCategories();
      } else if (activeSection === 'jobs') {
        fetchJobs();
      } else if (activeSection === 'jobApplications') {
        fetchJobApplications();
      } else if (activeSection === 'feedbacks') {
        fetchFeedbacks();
      } else if (activeSection === 'surveys') {
        fetchSurveys(1, surveysStatusFilter);
      } else if (activeSection === 'pastEventImages') {
        fetchPastEventImages();
        fetchEventsForPastEventImages();
      }
    }
  }, [isAuthenticated, activeSection]);

  const fetchDashboardStats = async () => {
    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/admin/dashboard`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setDashboardStats(data.data);
        }
      }
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
    }
  };

  const getTodayOTP = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}${month}${year}`;
  };

  const handleOTPSubmit = (e) => {
    e.preventDefault();
    const validOTP = getTodayOTP();
    
    if (otp === validOTP) {
      setIsAuthenticated(true);
      sessionStorage.setItem('adminAuth', 'true');
      sessionStorage.setItem('adminLoginTime', Date.now().toString());
      setOtpError('');
    } else {
      setOtpError('Invalid OTP. Please try again.');
      setOtp('');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    sessionStorage.removeItem('adminAuth');
    sessionStorage.removeItem('adminLoginTime');
    setOtp('');
    setOtpError('');
  };

  const fetchCourses = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/courses`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch courses');
      }

      const data = await response.json();
      if (data.success) {
        setCourses(data.data);
      } else {
        throw new Error('Failed to fetch courses');
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
      setCourses([]);
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchLeads = async () => {
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINTS.LEADS_ADMIN_ALL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch leads');
      }

      const data = await response.json();
      if (data.success) {
        setLeads(data.data);
      } else {
        throw new Error('Failed to fetch leads');
      }
    } catch (err) {
      console.error('Error fetching leads:', err);
      console.log('Using sample data as fallback');
      
      const sampleData = [
        { id: 88, name: "Dev mal", email: "dmal72636@gmail.com", createdAt: "2025-12-21T12:30:43.550Z", source: "live_session", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: false },
        { id: 87, name: "Dev mal", email: "dmal72636@gmail.com", createdAt: "2025-12-21T12:30:32.713Z", source: "course_outline", status: "Acknowledged", interestedIn: "training_info", mobile: null, consent: false },
        { id: 86, name: "Dev mal", email: "dmal72636@gmail.com", createdAt: "2025-12-21T12:30:23.940Z", source: "course_outline", status: "Acknowledged", interestedIn: "training_info", mobile: null, consent: false },
        { id: 85, name: "Dev mal", email: "dmal72636@gmail.com", createdAt: "2025-12-21T12:29:43.500Z", source: "live_session", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: false },
        { id: 84, name: "Dev", email: "dmal72636@gmail.com", createdAt: "2025-12-21T12:28:50.347Z", source: "live_session", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: false },
        { id: 83, name: "Dev", email: "dmal72636@gmail.com", createdAt: "2025-12-21T12:28:38.923Z", source: "live_session", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: false },
        { id: 82, name: "Dev mal", email: "dmal72636@gmail.com", createdAt: "2025-12-21T12:28:10.777Z", source: "copilot_training_hero_inline", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: false },
        { id: 81, name: "Dev mal", email: "dmal72636@gmail.com", createdAt: "2025-12-21T12:28:08.257Z", source: "copilot_training_hero_inline", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: false },
        { id: 80, name: "Chai1", email: "chai1@chai1.com", createdAt: "2025-12-19T17:18:14.380Z", source: "landing_page", status: "Acknowledged", interestedIn: "architect_program", mobile: "9448675828", consent: true },
        { id: 79, name: "Swathi", email: "brswathi99@gmail.com", createdAt: "2025-12-17T12:38:04.197Z", source: "copilot_training_hero_inline", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: null },
        { id: 78, name: "Swathi", email: "brswathi99@gmail.com", createdAt: "2025-12-17T12:38:02.357Z", source: "copilot_training_hero_inline", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: null },
        { id: 77, name: "Rami reddy", email: "morthalaramireddyvenkata@gmail.com", createdAt: "2025-12-15T11:03:39.003Z", source: "copilot_training_hero_inline", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: null },
        { id: 76, name: "Kundan", email: "tinkuthakur4368@gmail.com", createdAt: "2025-12-13T19:22:45.497Z", source: "course_outline", status: "Acknowledged", interestedIn: "training_info", mobile: null, consent: null },
        { id: 75, name: "Kundan", email: "tinkuthakur4368@gmail.com", createdAt: "2025-12-13T19:22:42.617Z", source: "live_session", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: null },
        { id: 74, name: "Kundan", email: "tinkuthakur4368@gmail.com", createdAt: "2025-12-13T19:22:16.830Z", source: "copilot_training_hero_inline", status: "Acknowledged", interestedIn: "copilot_training", mobile: null, consent: null }
      ];
      
      setLeads(sampleData);
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch users');
      }

      const data = await response.json();
      if (data.success) {
        setUsers(data.data);
      } else {
        throw new Error('Failed to fetch users');
      }
    } catch (err) {
      console.error('Error fetching users:', err);
      setUsers([]);
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchEnrollments = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/enrollments`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch enrollments');
      }

      const data = await response.json();
      if (data.success) {
        setEnrollments(data.data);
      } else {
        throw new Error('Failed to fetch enrollments');
      }
    } catch (err) {
      console.error('Error fetching enrollments:', err);
      setEnrollments([]);
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams();
      
      if (eventFilters.status) queryParams.append('status', eventFilters.status);
      if (eventFilters.location_type) queryParams.append('location_type', eventFilters.location_type);
      if (eventFilters.category_id) queryParams.append('category_id', eventFilters.category_id);
      if (eventFilters.upcoming) queryParams.append('upcoming', 'true');
      
      queryParams.append('limit', '100'); // Get more events
      
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/events?${queryParams.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch events');
      }

      const data = await response.json();
      if (data.success) {
        const rawEvents = Array.isArray(data.data)
          ? data.data
          : Array.isArray(data.data?.events)
            ? data.data.events
            : [];

        const normalizedEvents = rawEvents.map((event) => {
          const apiPrices = Array.isArray(event.prices) ? event.prices : [];
          const fallbackLegacyPrices = event.price !== null && event.price !== undefined
            ? [{
                currency: String(event.currency || 'INR').toUpperCase(),
                price: Number(event.price) || 0,
                isenabled: true
              }]
            : [];

          const normalizedPrices = (apiPrices.length > 0 ? apiPrices : fallbackLegacyPrices)
            .filter((priceItem) => priceItem && priceItem.currency)
            .map((priceItem) => ({
              currency: String(priceItem.currency).toUpperCase(),
              price: Number(priceItem.price) || 0,
              isenabled: priceItem.isenabled !== false && priceItem.is_enabled !== false
            }));

          return {
            ...event,
            prices: normalizedPrices
          };
        });

        setEvents(normalizedEvents);
      } else {
        throw new Error('Failed to fetch events');
      }
    } catch (err) {
      console.error('Error fetching events:', err);
      setEvents([]);
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchEventCategories = async () => {
    try {
      const response = await fetch(
        `${API_ENDPOINTS.BASE_URL}/events/categories/list?includeInactive=true`, 
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            [TOKEN_HEADER]: generateToken(),
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch event categories');
      }

      const data = await response.json();
      console.log('Event Categories Response:', data);
      if (data.success && Array.isArray(data.data)) {
        setEventCategories(data.data);
      } else {
        setEventCategories([]);
      }
    } catch (err) {
      console.error('Error fetching event categories:', err);
      setEventCategories([]);
    }
  };

  const fetchPastEventImages = async () => {
    try {
      setPastEventImagesLoading(true);
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/admin/past-event-images`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch past event images');
      }

      const data = await response.json();
      const images = Array.isArray(data)
        ? data
        : Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data?.images)
            ? data.images
            : [];

      setPastEventImages(images);
    } catch (err) {
      console.error('Error fetching past event images:', err);
      setPastEventImages([]);
      setError(null);
    } finally {
      setPastEventImagesLoading(false);
    }
  };

  const fetchEventsForPastEventImages = async () => {
    try {
      setPastEventImageEventsLoading(true);
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/events?limit=100`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch events for image mapping');
      }

      const data = await response.json();
      const rawEvents = Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data?.events)
          ? data.events
          : [];

      setPastEventImageEvents(rawEvents);
    } catch (err) {
      console.error('Error fetching events for past event images:', err);
      setPastEventImageEvents([]);
    } finally {
      setPastEventImageEventsLoading(false);
    }
  };

  const handlePastEventImageUpload = async (e) => {
    e.preventDefault();

    if (!pastEventImageFormData.event_id) {
      alert('Please select an event.');
      return;
    }

    if (!pastEventImageFile) {
      alert('Please select an image file to upload.');
      return;
    }

    if (pastEventImageFile.size > 8 * 1024 * 1024) {
      alert('Please upload an image under 8 MB.');
      return;
    }

    try {
      setPastEventImageUploading(true);
      const formData = new FormData();
      formData.append('image', pastEventImageFile);
      formData.append('event_id', pastEventImageFormData.event_id);
      formData.append('eventid', pastEventImageFormData.event_id);
      formData.append('title', pastEventImageFormData.title.trim());
      formData.append('event_date', pastEventImageFormData.event_date || '');
      formData.append('alt_text', pastEventImageFormData.alt_text.trim());
      formData.append('tags', pastEventImageFormData.tags.trim());

      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/admin/past-event-images`, {
        method: 'POST',
        headers: {
          [TOKEN_HEADER]: generateToken(),
        },
        body: formData,
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok || data?.success === false) {
        throw new Error(data?.message || 'Failed to upload image');
      }

      alert('Past event image uploaded successfully.');
      setPastEventImageFormData({
        event_id: '',
        title: '',
        event_date: '',
        alt_text: '',
        tags: ''
      });
      setPastEventImageFile(null);
      fetchPastEventImages();
    } catch (err) {
      alert(`Upload failed: ${err.message}`);
    } finally {
      setPastEventImageUploading(false);
    }
  };

  const handleDeletePastEventImage = async (imageId) => {
    if (!window.confirm('Delete this image permanently?')) {
      return;
    }

    try {
      setActionLoading(`past-image-${imageId}`);
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/admin/past-event-images/${imageId}`, {
        method: 'DELETE',
        headers: {
          [TOKEN_HEADER]: generateToken(),
        },
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok || data?.success === false) {
        throw new Error(data?.message || 'Failed to delete image');
      }

      setPastEventImages((prev) => prev.filter((item) => String(item.id || item.image_id) !== String(imageId)));
    } catch (err) {
      alert(`Delete failed: ${err.message}`);
    } finally {
      setActionLoading(null);
    }
  };

  const getPastEventImageUrl = (item) => {
    return item.image_url_signed || item.image_url || item.imageUrl || item.url || item.secure_url || '';
  };

  const handleCopyPastEventImageUrl = async (item) => {
    const imageUrl = getPastEventImageUrl(item);
    if (!imageUrl) {
      alert('No image URL available to copy.');
      return;
    }

    try {
      await navigator.clipboard.writeText(imageUrl);
      alert('Image URL copied to clipboard.');
    } catch (error) {
      alert('Unable to copy URL. Please copy it manually.');
    }
  };

  const fetchFeedbacks = async () => {
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINTS.EVENT_FEEDBACK_ADMIN_LIST, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch feedbacks');
      }

      const data = await response.json();
      if (data.success) {
        setFeedbacks(Array.isArray(data.data) ? data.data : []);
      } else {
        throw new Error('Failed to fetch feedbacks');
      }
    } catch (err) {
      console.error('Error fetching feedbacks:', err);
      setFeedbacks([]);
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  const handleFeedbackApproval = async (feedbackId, approved) => {
    setActionLoading(`feedback-${feedbackId}`);
    try {
      const response = await fetch(
        approved
          ? API_ENDPOINTS.EVENT_FEEDBACK_APPROVE(feedbackId)
          : API_ENDPOINTS.EVENT_FEEDBACK_DISAPPROVE(feedbackId),
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            [TOKEN_HEADER]: generateToken(),
          },
        }
      );

      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Failed to update feedback approval');
      }

      setFeedbacks((prev) => prev.map((item) => (
        item.id === feedbackId ? { ...item, approved } : item
      )));
    } catch (error) {
      console.error('Error updating feedback approval:', error);
      alert(`Failed to update feedback: ${error.message}`);
    } finally {
      setActionLoading(null);
    }
  };
 
  // Calculate duplicates first
  const duplicateMap = {};
  const duplicateLeadIds = new Set();
  
  leads.forEach(lead => {
    const key = `${lead.email}_${lead.interestedIn}`;
    if (!duplicateMap[key]) {
      duplicateMap[key] = [];
    }
    duplicateMap[key].push(lead.id);
  });

  Object.values(duplicateMap).forEach(ids => {
    if (ids.length > 1) {
      // Skip the first ID (keep it as valid), mark rest as duplicates
      ids.slice(1).forEach(id => duplicateLeadIds.add(id));
    }
  });

  const duplicateCount = duplicateLeadIds.size;

  // Calculate lead age (days since creation)
  const leadsWithAge = leads.map(lead => {
    const createdDate = new Date(lead.createdAt);
    const today = new Date();
    const diffTime = Math.abs(today - createdDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return { ...lead, age: diffDays };
  });

  // Then filter leads
  let filteredLeads = leadsWithAge;
  
  // Filter by interested in
  if (interestedInFilter !== 'All') {
    filteredLeads = filteredLeads.filter(lead => lead.interestedIn === interestedInFilter);
  }
  
  // Filter by series (age in days)
  if (seriesFilter !== 'All') {
    const seriesNum = parseInt(seriesFilter);
    filteredLeads = filteredLeads.filter(lead => lead.age === seriesNum);
  }

  // Filter by source
  if (sourceFilter !== 'All') {
    filteredLeads = filteredLeads.filter(lead => lead.source === sourceFilter);
  }

  // Filter by search query (name, email, mobile)
  if (searchQuery.trim() !== '') {
    const query = searchQuery.toLowerCase();
    filteredLeads = filteredLeads.filter(lead => 
      (lead.name && lead.name.toLowerCase().includes(query)) ||
      (lead.email && lead.email.toLowerCase().includes(query)) ||
      (lead.mobile && lead.mobile.toLowerCase().includes(query))
    );
  }

  // Filter based on duplicate view
  if (showOnlyDuplicates) {
    filteredLeads = filteredLeads.filter(lead => duplicateLeadIds.has(lead.id));
  } else {
    filteredLeads = filteredLeads.filter(lead => !duplicateLeadIds.has(lead.id));
  }
  
  const totalPages = Math.ceil(filteredLeads.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentLeads = filteredLeads.slice(startIndex, endIndex);

  const interestedInOptions = ['All', ...new Set(leads.map(lead => lead.interestedIn).filter(Boolean))];
  const sourceOptions = ['All', ...new Set(leads.map(lead => lead.source).filter(Boolean))];

  const categoryCounts = {};
  leads.forEach(lead => {
    if (lead.interestedIn) {
      categoryCounts[lead.interestedIn] = (categoryCounts[lead.interestedIn] || 0) + 1;
    }
  });

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleFilterChange = (value) => {
    setInterestedInFilter(value);
    setCurrentPage(1);
  };

  const handleDuplicateClick = () => {
    setShowOnlyDuplicates(!showOnlyDuplicates);
    setInterestedInFilter('All');
    setCurrentPage(1);
  };

  const handleCategoryClick = (category) => {
    setShowOnlyDuplicates(false);
    if (interestedInFilter === category) {
      setInterestedInFilter('All');
    } else {
      setInterestedInFilter(category);
    }
    setCurrentPage(1);
  };

  const handleSendEmail = (lead) => {
    setSelectedLead(lead);
    const emailOptions = EMAIL_CONFIG[lead.interestedIn] || [];
    const defaultLevel = emailOptions.length > 0 ? emailOptions[0].template : 'copilot_welcome';
    setEmailLevel(defaultLevel);
    setShowEmailModal(true);
  };

  const handleEmailSubmit = async () => {
    if (!selectedLead || !emailLevel) return;
    
    setActionLoading(selectedLead.id);
    setShowEmailModal(false);
    
    try {
      // Find the selected email config to get the level
      const emailOptions = EMAIL_CONFIG[selectedLead.interestedIn] || [];
      const selectedEmailConfig = emailOptions.find(option => option.template === emailLevel);
      const emailLevelNumber = selectedEmailConfig ? selectedEmailConfig.level : 1;
      
      const response = await fetch(`${API_ENDPOINTS.LEADS_ADMIN_SEND_EMAIL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
        body: JSON.stringify({
          leadid: selectedLead.id,
          email: selectedLead.email,
          name: selectedLead.name,
          level: emailLevelNumber,
          programkey: selectedLead.interestedIn
        })
      });

      const data = await response.json();
      
      if (response.ok && data.success) {
        alert(`Email sent successfully to ${selectedLead.email}!`);
        // Refresh leads to update email count
        fetchLeads();
      } else {
        throw new Error(data.message || 'Failed to send email');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      alert(`Failed to send email: ${error.message}`);
    } finally {
      setActionLoading(null);
      setSelectedLead(null);
    }
  };

  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
    setSelectedLead(null);
    setEmailLevel('copilot_welcome');
  };

  const getEventDateValue = (event) => {
    return event?.start_datetime || event?.start_date || event?.event_date || event?.date || null;
  };

  const formatEventDateForOption = (event) => {
    const rawDate = getEventDateValue(event);
    if (!rawDate) {
      return '';
    }

    const parsed = new Date(rawDate);
    if (Number.isNaN(parsed.getTime())) {
      return '';
    }

    return parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const fetchUpcomingEventsForNewLead = async () => {
    try {
      setNewLeadEventsLoading(true);

      const queryParams = new URLSearchParams();
      queryParams.append('upcoming', 'true');
      queryParams.append('limit', '200');

      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/events?${queryParams.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch upcoming events');
      }

      const data = await response.json();
      const rawEvents = Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data?.data?.events)
          ? data.data.events
          : [];

      const now = new Date();
      const upcomingEvents = rawEvents
        .filter((event) => {
          const eventDate = getEventDateValue(event);
          if (!eventDate) {
            return false;
          }

          const parsedDate = new Date(eventDate);
          return !Number.isNaN(parsedDate.getTime()) && parsedDate >= now;
        })
        .sort((a, b) => new Date(getEventDateValue(a)) - new Date(getEventDateValue(b)));

      setNewLeadUpcomingEvents(upcomingEvents);
    } catch (error) {
      console.error('Error fetching upcoming events for new lead form:', error);
      setNewLeadUpcomingEvents([]);
    } finally {
      setNewLeadEventsLoading(false);
    }
  };

  const handleOpenNewLeadModal = () => {
    setShowNewLeadModal(true);
    setNewLeadError('');
    fetchUpcomingEventsForNewLead();
  };

  const handleCloseNewLeadModal = () => {
    setShowNewLeadModal(false);
    setNewLeadError('');
    setNewLeadProfilePdf(null);
    setNewLeadFormData({
      name: '',
      email: '',
      mobile: '',
      consent: false,
      interestedIn: 'copilot_training',
      status: 'New'
    });
  };

  const handleNewLeadFieldChange = (field, value) => {
    setNewLeadFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleNewLeadPdfChange = (event) => {
    const selectedFile = event.target.files?.[0] || null;

    if (!selectedFile) {
      setNewLeadProfilePdf(null);
      return;
    }

    const isPdfType = selectedFile.type === 'application/pdf' || selectedFile.name.toLowerCase().endsWith('.pdf');
    if (!isPdfType) {
      setNewLeadError('Only PDF files are allowed for profile attachment.');
      setNewLeadProfilePdf(null);
      event.target.value = '';
      return;
    }

    setNewLeadError('');
    setNewLeadProfilePdf(selectedFile);
  };

  const handleCreateNewLead = async (event) => {
    event.preventDefault();

    if (!newLeadFormData.name.trim() || !newLeadFormData.email.trim()) {
      setNewLeadError('Name and email are required.');
      return;
    }

    setNewLeadSubmitting(true);
    setNewLeadError('');

    try {
      const payload = new FormData();
      payload.append('name', newLeadFormData.name.trim());
      payload.append('email', newLeadFormData.email.trim());
      payload.append('consent', String(Boolean(newLeadFormData.consent)));
      payload.append('interestedIn', newLeadFormData.interestedIn);
      payload.append('status', 'New');
      payload.append('source', 'admin_manual');

      if (newLeadFormData.mobile.trim()) {
        payload.append('mobile', newLeadFormData.mobile.trim());
      }

      if (newLeadProfilePdf) {
        payload.append('profilePdf', newLeadProfilePdf);
      }

      const response = await fetch(API_ENDPOINTS.LEADS_ADMIN_CREATE, {
        method: 'POST',
        headers: {
          [TOKEN_HEADER]: generateToken(),
        },
        body: payload,
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data?.message || 'Failed to create lead');
      }

      handleCloseNewLeadModal();
      await fetchLeads();
      alert('New lead created successfully.');
    } catch (error) {
      console.error('Error creating new lead:', error);
      setNewLeadError(error.message || 'Failed to create lead.');
    } finally {
      setNewLeadSubmitting(false);
    }
  };

  const handleDelete = async (leadId, name) => {
    if (!window.confirm(`Are you sure you want to delete lead "${name}"?`)) return;
    
    setActionLoading(leadId);
    try {
      const response = await fetch(API_ENDPOINTS.LEADS_ADMIN_DELETE(leadId), {
        method: 'DELETE',
        headers: {
          [TOKEN_HEADER]: generateToken(),
        },
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data?.message || 'Failed to delete lead');
      }

      setLeads(leads.filter(lead => lead.id !== leadId));
      alert('Lead deleted successfully!');
    } catch (error) {
      console.error('Error deleting lead:', error);
      alert(`Failed to delete lead: ${error.message}`);
    } finally {
      setActionLoading(null);
    }
  };

  const getMarketingInsightsPayload = (lead) => {
    const seeded = {
      ...MOCK_MARKETING_INSIGHTS_RESPONSE,
      MarketingEmail: (MOCK_MARKETING_INSIGHTS_RESPONSE.MarketingEmail || []).map((item) => ({ ...item }))
    };

    const leadName = lead?.name || 'Lead';
    const leadEmail = lead?.email || 'N/A';
    seeded.Summary = seeded.Summary.replace(
      'Chaitanya Allidona (contact: chaitanya.allidona@outlook.com)',
      `${leadName} (contact: ${leadEmail})`
    );

    seeded.MarketingEmail = seeded.MarketingEmail.map((item) => ({
      ...item,
      Body: (item.Body || '').replace(/Hi Chaitanya/gi, `Hi ${leadName}`)
    }));

    return seeded;
  };

  const parseInsightsOutputText = (outputText) => {
    const raw = typeof outputText === 'string' ? outputText.trim() : '';
    if (!raw) {
      return null;
    }

    const fencedJsonMatch = raw.match(/^```(?:json)?\s*([\s\S]*?)\s*```$/i);
    const jsonCandidate = fencedJsonMatch ? fencedJsonMatch[1].trim() : raw;

    try {
      return JSON.parse(jsonCandidate);
    } catch (_error) {
      return null;
    }
  };

  const formatInsightsValue = (value) => {
    if (value === null || value === undefined) {
      return 'N/A';
    }

    if (typeof value === 'string') {
      return value;
    }

    if (typeof value === 'number' || typeof value === 'boolean') {
      return String(value);
    }

    try {
      return JSON.stringify(value, null, 2);
    } catch (_error) {
      return 'N/A';
    }
  };

  const normalizeMarketingEmailItem = (item, index) => {
    const safeItem = item && typeof item === 'object' ? item : {};
    return {
      Subject: formatInsightsValue(safeItem.Subject ?? safeItem.subject ?? ''),
      Body: formatInsightsValue(safeItem.Body ?? safeItem.body ?? ''),
      CTA: formatInsightsValue(safeItem.CTA ?? safeItem.cta ?? ''),
      Level: Number.parseInt(safeItem.Level ?? safeItem.level, 10) || index + 1,
    };
  };

  const normalizeMarketingInsightsPayload = (payload) => {
    const safePayload = payload && typeof payload === 'object' ? payload : {};
    const pickFirst = (...values) => values.find((value) => value !== undefined && value !== null);

    const summaryValue = pickFirst(
      safePayload.Summary,
      safePayload.summary,
      safePayload['Lead Summary'],
      safePayload.leadSummary
    );

    const channelInsightsValue = pickFirst(
      safePayload.ChannelInsights,
      safePayload.channelInsights,
      safePayload['Channel Insights'],
      safePayload.channel_insights,
      safePayload.ChannelInsight,
      safePayload.channelInsight
    );

    const marketingEmailValue = pickFirst(
      safePayload.MarketingEmail,
      safePayload.marketingEmail,
      safePayload['Marketing Email'],
      safePayload.emails
    );

    const marketingEmailRaw = Array.isArray(safePayload.MarketingEmail)
      ? safePayload.MarketingEmail
      : Array.isArray(marketingEmailValue)
        ? marketingEmailValue
      : [];

    return {
      Summary: formatInsightsValue(summaryValue),
      ChannelInsights: channelInsightsValue,
      MarketingEmail: marketingEmailRaw.map((item, index) => normalizeMarketingEmailItem(item, index)),
    };
  };

  const tryParseJsonString = (value) => {
    if (typeof value !== 'string') {
      return value;
    }

    const trimmed = value.trim();
    if (!trimmed || (!trimmed.startsWith('{') && !trimmed.startsWith('['))) {
      return value;
    }

    try {
      return JSON.parse(trimmed);
    } catch (_error) {
      return value;
    }
  };

  const renderChannelInsights = (value) => {
    const parsedValue = tryParseJsonString(value);

    if (parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue)) {
      const bestChannel = parsedValue.BestChannel || parsedValue.bestChannel || parsedValue.primaryChannel || null;
      const rationale = parsedValue.Rationale || parsedValue.rationale || null;
      const secondaryChannelsRaw =
        parsedValue.SecondaryChannels ||
        parsedValue.secondaryChannels ||
        parsedValue.AlternativeChannels ||
        parsedValue.alternativeChannels ||
        [];

      const secondaryChannels = Array.isArray(secondaryChannelsRaw)
        ? secondaryChannelsRaw
        : (secondaryChannelsRaw ? [secondaryChannelsRaw] : []);

      return (
        <div style={{ display: 'grid', gap: '8px', color: '#C8D6E2' }}>
          {bestChannel && (
            <div>
              <div style={{ fontSize: '12px', fontWeight: 700, color: '#9DB0BF', marginBottom: '2px' }}>Best Channel</div>
              <div style={{ fontSize: '13px', lineHeight: 1.5 }}>{formatInsightsValue(bestChannel)}</div>
            </div>
          )}

          {rationale && (
            <div>
              <div style={{ fontSize: '12px', fontWeight: 700, color: '#9DB0BF', marginBottom: '2px' }}>Rationale</div>
              <div style={{ fontSize: '13px', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{formatInsightsValue(rationale)}</div>
            </div>
          )}

          {secondaryChannels.length > 0 && (
            <div>
              <div style={{ fontSize: '12px', fontWeight: 700, color: '#9DB0BF', marginBottom: '4px' }}>Secondary Channels</div>
              <ul style={{ margin: 0, paddingLeft: '18px' }}>
                {secondaryChannels.map((channel, idx) => (
                  <li key={`secondary-channel-${idx}`} style={{ fontSize: '13px', lineHeight: 1.5, marginBottom: '3px' }}>
                    {formatInsightsValue(channel)}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {!bestChannel && !rationale && secondaryChannels.length === 0 && (
            <div style={{ fontSize: '13px', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
              {formatInsightsValue(parsedValue)}
            </div>
          )}
        </div>
      );
    }

    return (
      <div style={{ fontSize: '13px', lineHeight: 1.5, whiteSpace: 'pre-wrap', color: '#C8D6E2' }}>
        {formatInsightsValue(parsedValue)}
      </div>
    );
  };

  const handleOpenInsights = async (lead) => {
    if (!lead?.id) {
      return;
    }

    setActionLoading(lead.id);

    try {
      const response = await fetch(API_ENDPOINTS.LEADS_ADMIN_MARKETING_INSIGHTS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
        body: JSON.stringify({
          leadId: lead.id
        })
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok || data?.success === false) {
        throw new Error(data?.message || 'Failed to generate marketing insights');
      }

      const resolvedPayload =
        data?.data?.outputJson ||
        parseInsightsOutputText(data?.data?.outputText) ||
        getMarketingInsightsPayload(lead);

      const normalizedPayload = normalizeMarketingInsightsPayload(resolvedPayload);

      setInsightsLead(lead);
      setInsightsPayload(normalizedPayload);
      setEditableInsightsEmails((normalizedPayload.MarketingEmail || []).map((item) => ({ ...item })));
      setShowInsightsModal(true);
    } catch (error) {
      console.error('Error fetching marketing insights:', error);
      alert(`Failed to fetch marketing insights: ${error.message}`);
    } finally {
      setActionLoading(null);
    }
  };

  const handleCloseInsightsModal = () => {
    setShowInsightsModal(false);
    setInsightsLead(null);
    setInsightsPayload(null);
    setEditableInsightsEmails([]);
    setInsightEmailSendingLevel(null);
  };

  const getLeadProfilePdfUrl = (lead) => (
    lead?.profilePdfUrl || lead?.profilepdfurl || null
  );

  const handleInsightsEmailFieldChange = (level, field, value) => {
    setEditableInsightsEmails((prev) => prev.map((item) => (
      item.Level === level ? { ...item, [field]: value } : item
    )));
  };

  const handleSendInsightsEmail = async (emailItem) => {
    if (!insightsLead || !emailItem) return;

    setInsightEmailSendingLevel(emailItem.Level);
    try {
      const response = await fetch(`${API_ENDPOINTS.LEADS_ADMIN_SEND_EMAIL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
        body: JSON.stringify({
          leadid: insightsLead.id,
          email: insightsLead.email,
          name: insightsLead.name,
          level: emailItem.Level,
          programkey: insightsLead.interestedIn,
          subject: emailItem.Subject,
          body: emailItem.Body,
          cta: emailItem.CTA,
          source: 'marketing_insights_popup'
        })
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok || (data && data.success === false)) {
        throw new Error(data?.message || 'Failed to send insights email');
      }

      alert(`Insights email (Level ${emailItem.Level}) sent to ${insightsLead.email}`);
    } catch (error) {
      console.error('Error sending insights email:', error);
      alert(`Failed to send insights email: ${error.message}`);
    } finally {
      setInsightEmailSendingLevel(null);
    }
  };

  const getFunnelStageMeta = (index) => {
    const stages = [
      { label: 'Awareness', accent: '#9DB0BF', bg: '#1A2A38', border: 'rgba(157,176,191,0.35)' },
      { label: 'Consideration', accent: '#F59E0B', bg: '#223445', border: 'rgba(245,158,11,0.45)' },
      { label: 'Conversion', accent: '#34D399', bg: '#1E3432', border: 'rgba(52,211,153,0.45)' }
    ];

    return stages[index] || stages[stages.length - 1];
  };

  const handleConvertLeadToUser = async (lead) => {
    if (!window.confirm(`Convert lead "${lead.name}" to a user account?\n\nThis will create a new user with:\n- Email: ${lead.email}\n- Name: ${lead.name}\n- Phone: ${lead.mobile || 'N/A'}\n\nA password will be generated and should be sent to the user.`)) {
      return;
    }
    
    setActionLoading(lead.id);
    try {
      // Parse name into first and last name
      const nameParts = lead.name.trim().split(' ');
      const firstName = nameParts[0] || lead.name;
      const lastName = nameParts.slice(1).join(' ') || nameParts[0];

      // Create user via API
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
        body: JSON.stringify({
          email: lead.email,
          first_name: firstName,
          last_name: lastName,
          phone: lead.mobile || null,
          role: 'student',
          generate_password: true
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        alert(`User created successfully!\n\nUser ID: ${data.data.id}\nEmail: ${data.data.email}\n\nA password has been generated. Please send it to the user via email.`);
        // Optionally update lead status
        setLeads(leads.map(l => 
          l.id === lead.id ? { ...l, status: 'Converted' } : l
        ));
      } else {
        throw new Error(data.error || 'Failed to create user');
      }
    } catch (error) {
      console.error('Error converting lead to user:', error);
      alert(`Failed to convert lead to user: ${error.message}`);
    } finally {
      setActionLoading(null);
    }
  };

  const handleChangeStatus = (lead) => {
    setSelectedLead(lead);
    setNewStatus(lead.status || 'New');
    setShowStatusModal(true);
  };

  const handleStatusSubmit = async () => {
    if (!selectedLead || !newStatus) return;
    
    setActionLoading(selectedLead.id);
    setShowStatusModal(false);
    
    try {
      // TODO: Implement status update API call
      console.log('Changing status for lead:', selectedLead.id, 'to:', newStatus);
      setLeads(leads.map(lead => 
        lead.id === selectedLead.id ? { ...lead, status: newStatus } : lead
      ));
      alert('Status updated successfully!');
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Failed to update status');
    } finally {
      setActionLoading(null);
      setSelectedLead(null);
    }
  };

  const handleCloseStatusModal = () => {
    setShowStatusModal(false);
    setSelectedLead(null);
    setNewStatus('');
  };

  const handleOpenCourseModal = () => {
    setIsEditMode(false);
    setEditingCourseId(null);
    setCourseFormData({
      course_code: '',
      title: '',
      slug: '',
      short_description: '',
      description: '',
      thumbnail_url: '',
      preview_video_url: '',
      category: '',
      level: 'beginner',
      language: 'English',
      duration_hours: 0,
      instructor_id: '',
      price: 0,
      is_published: false,
      is_featured: false,
      enrollment_limit: 0,
      prerequisites: '',
      learning_outcomes: '',
      target_audience: '',
      certificate_available: true
    });
    setShowCourseModal(true);
  };

  const handleEditCourse = (course) => {
    setIsEditMode(true);
    setEditingCourseId(course.id);
    
    // Parse JSON strings back to text format
    let prerequisitesText = '';
    let learningOutcomesText = '';
    
    try {
      if (course.prerequisites) {
        const prereqArray = JSON.parse(course.prerequisites);
        prerequisitesText = Array.isArray(prereqArray) ? prereqArray.join('\n') : '';
      }
    } catch (e) {
      prerequisitesText = course.prerequisites || '';
    }
    
    try {
      if (course.learning_outcomes) {
        const outcomesArray = JSON.parse(course.learning_outcomes);
        learningOutcomesText = Array.isArray(outcomesArray) ? outcomesArray.join('\n') : '';
      }
    } catch (e) {
      learningOutcomesText = course.learning_outcomes || '';
    }
    
    setCourseFormData({
      course_code: course.course_code || '',
      title: course.title || '',
      slug: course.slug || '',
      short_description: course.short_description || '',
      description: course.description || '',
      thumbnail_url: course.thumbnail_url || '',
      preview_video_url: course.preview_video_url || '',
      category: course.category || '',
      level: course.level || 'beginner',
      language: course.language || 'English',
      duration_hours: course.duration_hours || 0,
      instructor_id: course.instructor_id || '',
      price_usd: course.price_usd || course.price || 0,
      price_inr: course.price_inr || 0,
      price_aud: course.price_aud || 0,
      is_published: course.is_published || false,
      is_featured: course.is_featured || false,
      enrollment_limit: course.enrollment_limit || 0,
      prerequisites: prerequisitesText,
      learning_outcomes: learningOutcomesText,
      target_audience: course.target_audience || '',
      certificate_available: course.certificate_available !== false
    });
    setShowCourseModal(true);
  };

  const handleCloseCourseModal = () => {
    setShowCourseModal(false);
    setIsEditMode(false);
    setEditingCourseId(null);
  };

  const handleCourseFormChange = (field, value) => {
    setCourseFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleManageModules = async (course) => {
    setSelectedCourse(course);
    setUploadedModules([]);
    setXlsxFile(null);
    setExistingModules([]);
    setShowModulesModal(true);
    
    // Fetch existing modules
    setLoadingModules(true);
    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/courses/${course.id}/modules`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });
      if (response.ok) {
        const data = await response.json();
        setExistingModules(data.data || []);
      } else {
        console.error('Failed to fetch modules');
      }
    } catch (error) {
      console.error('Error fetching modules:', error);
    } finally {
      setLoadingModules(false);
    }
  };

  const handleCloseModulesModal = () => {
    setShowModulesModal(false);
    setSelectedCourse(null);
    setUploadedModules([]);
    setXlsxFile(null);
    setExistingModules([]);
    setLoadingModules(false);
    setExpandedModules(new Set());
    setModuleLessons({});
    setLoadingLessons({});
  };

  const toggleModuleExpand = async (moduleId) => {
    setExpandedModules(prev => {
      const newSet = new Set(prev);
      const isExpanding = !newSet.has(moduleId);
      
      if (newSet.has(moduleId)) {
        newSet.delete(moduleId);
      } else {
        newSet.add(moduleId);
      }
      
      // Fetch lessons if expanding and not already loaded
      if (isExpanding && !moduleLessons[moduleId]) {
        fetchLessonsForModule(moduleId);
      }
      
      return newSet;
    });
  };

  const fetchLessonsForModule = async (moduleId) => {
    setLoadingLessons(prev => ({ ...prev, [moduleId]: true }));
    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/courses/modules/${moduleId}/lessons`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
      });
      
      if (response.ok) {
        const data = await response.json();
        setModuleLessons(prev => ({ ...prev, [moduleId]: data.data || [] }));
      } else {
        console.error('Failed to fetch lessons for module:', moduleId);
        setModuleLessons(prev => ({ ...prev, [moduleId]: [] }));
      }
    } catch (error) {
      console.error('Error fetching lessons:', error);
      setModuleLessons(prev => ({ ...prev, [moduleId]: [] }));
    } finally {
      setLoadingLessons(prev => ({ ...prev, [moduleId]: false }));
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setXlsxFile(file);
    
    try {
      // Dynamically import xlsx library
      const XLSX = await import('xlsx');
      
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          // Assume first sheet contains the data
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(firstSheet);
          
          // Parse and structure the data
          const modulesMap = {};
          
          jsonData.forEach(row => {
            const moduleTitle = row['Module Title'] || row['module_title'] || row['Module'];
            const moduleOrder = parseInt(row['Module Order'] || row['module_order'] || 0);
            const moduleDesc = row['Module Description'] || row['module_description'] || '';
            
            const lessonTitle = row['Lesson Title'] || row['lesson_title'] || row['Lesson'];
            const lessonOrder = parseInt(row['Lesson Order'] || row['lesson_order'] || 0);
            const lessonSlug = row['Lesson Slug'] || row['lesson_slug'] || '';
            const contentType = row['Content Type'] || row['content_type'] || 'text';
            const content = row['Content'] || row['content'] || '';
            const videoUrl = row['Video URL'] || row['video_url'] || '';
            const duration = parseInt(row['Duration (min)'] || row['duration'] || 0);
            const isPreview = (row['Is Preview'] || row['is_preview'] || '').toString().toLowerCase() === 'true';
            
            if (!moduleTitle) return;
            
            if (!modulesMap[moduleTitle]) {
              modulesMap[moduleTitle] = {
                title: moduleTitle,
                description: moduleDesc,
                display_order: moduleOrder,
                lessons: []
              };
            }
            
            if (lessonTitle) {
              modulesMap[moduleTitle].lessons.push({
                title: lessonTitle,
                slug: lessonSlug || lessonTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
                content_type: contentType,
                content: content,
                video_url: videoUrl,
                display_order: lessonOrder,
                estimated_duration: duration,
                is_preview: isPreview
              });
            }
          });
          
          const modules = Object.values(modulesMap).sort((a, b) => a.display_order - b.display_order);
          setUploadedModules(modules);
          
          if (modules.length === 0) {
            alert('⚠️ No valid data found in the file.\n\nPlease ensure your Excel file has the correct column headers.');
          }
        } catch (error) {
          console.error('Error parsing Excel file:', error);
          alert('❌ Error parsing Excel file\n\n' + error.message);
        }
      };
      
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.error('Error loading xlsx library:', error);
      alert('❌ Error\n\nPlease install xlsx package: npm install xlsx');
    }
  };

  const handleUploadModules = async () => {
    if (uploadedModules.length === 0) {
      alert('⚠️ No modules to upload\n\nPlease upload an Excel file first.');
      return;
    }

    try {
      setActionLoading('modules-upload');
      
      let successCount = 0;
      let failedModules = [];
      
      // Upload each module sequentially
      for (const module of uploadedModules) {
        try {
          const moduleData = {
            title: module.title,
            description: module.description || '',
            display_order: module.display_order || 1,
            is_published: module.is_published !== false,
            lessons: (module.lessons || []).map(lesson => ({
              title: lesson.title,
              slug: lesson.slug || lesson.title.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
              content_type: lesson.content_type || 'text',
              content: lesson.content || '',
              video_url: lesson.video_url || '',
              video_duration: lesson.video_duration || 0,
              display_order: lesson.display_order || 1,
              estimated_duration: lesson.estimated_duration || 0,
              is_preview: lesson.is_preview || false
            }))
          };

          const response = await fetch(`${API_ENDPOINTS.BASE_URL}/courses/${selectedCourse.id}/modules`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              [TOKEN_HEADER]: generateToken(),
            },
            body: JSON.stringify(moduleData)
          });

          const data = await response.json();
          
          if (response.ok && data.success) {
            successCount++;
          } else {
            failedModules.push({
              title: module.title,
              error: data.message || 'Unknown error'
            });
          }
        } catch (error) {
          failedModules.push({
            title: module.title,
            error: error.message
          });
        }
      }
      
      // Show results
      if (failedModules.length === 0) {
        alert(`✅ Success!\n\n${successCount} module(s) uploaded successfully for course "${selectedCourse.title}".`);
        handleCloseModulesModal();
        fetchCourses();
      } else if (successCount > 0) {
        const failedList = failedModules.map(m => `• ${m.title}: ${m.error}`).join('\n');
        alert(`⚠️ Partial Success\n\n${successCount} module(s) uploaded successfully.\n${failedModules.length} module(s) failed:\n\n${failedList}`);
      } else {
        const failedList = failedModules.map(m => `• ${m.title}: ${m.error}`).join('\n');
        throw new Error(`All modules failed to upload:\n\n${failedList}`);
      }
    } catch (error) {
      console.error('Error uploading modules:', error);
      alert(`❌ Error Uploading Modules\n\n${error.message}`);
    } finally {
      setActionLoading(null);
    }
  };

  const handleCreateCourse = async () => {
    try {
      setActionLoading('course-create');
      
      // Convert prerequisites and learning_outcomes from text to JSON arrays
      const prerequisitesArray = courseFormData.prerequisites
        .split('\n')
        .map(item => item.trim())
        .filter(item => item.length > 0);
      
      const learningOutcomesArray = courseFormData.learning_outcomes
        .split('\n')
        .map(item => item.trim())
        .filter(item => item.length > 0);
      
      // Prepare data for API
      const courseData = {
        course_code: courseFormData.course_code.trim(),
        title: courseFormData.title.trim(),
        slug: courseFormData.slug.trim(),
        short_description: courseFormData.short_description.trim() || null,
        description: courseFormData.description.trim() || null,
        thumbnail_url: courseFormData.thumbnail_url.trim() || null,
        preview_video_url: courseFormData.preview_video_url.trim() || null,
        category: courseFormData.category.trim() || null,
        level: courseFormData.level,
        language: courseFormData.language.trim() || 'English',
        duration_hours: parseInt(courseFormData.duration_hours) || 0,
        instructor_id: 1,
        price_usd: parseFloat(courseFormData.price_usd) || 0,
        price_inr: parseFloat(courseFormData.price_inr) || 0,
        price_aud: parseFloat(courseFormData.price_aud) || 0,
        is_published: courseFormData.is_published,
        is_featured: courseFormData.is_featured,
        enrollment_limit: parseInt(courseFormData.enrollment_limit) || null,
        prerequisites: JSON.stringify(prerequisitesArray),
        learning_outcomes: JSON.stringify(learningOutcomesArray),
        target_audience: courseFormData.target_audience.trim() || null,
        certificate_available: courseFormData.certificate_available
      };

      const isEditing = isEditMode && editingCourseId;
      const url = isEditing 
        ? `${API_ENDPOINTS.BASE_URL}/courses/${editingCourseId}`
        : `${API_ENDPOINTS.BASE_URL}/courses`;
      const method = isEditing ? 'PUT' : 'POST';

      console.log(`${isEditing ? 'Updating' : 'Creating'} course with data:`, courseData);

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
        body: JSON.stringify(courseData)
      });

      const data = await response.json();
      
      if (response.ok && data.success) {
        const action = isEditing ? 'updated' : 'created';
        alert(`✅ Success!\n\nCourse "${courseData.title}" has been ${action} successfully.\n\nCourse ID: ${data.data?.id || editingCourseId || 'N/A'}\nCourse Code: ${courseData.course_code}`);
        handleCloseCourseModal();
        fetchCourses();
      } else {
        // Handle validation errors
        if (response.status === 400 && data.errors) {
          // Format validation errors
          const errorMessages = Object.entries(data.errors)
            .map(([field, message]) => `• ${field}: ${message}`)
            .join('\n');
          throw new Error(`Validation Failed:\n\n${errorMessages}`);
        } else if (response.status === 409) {
          // Handle duplicate errors
          throw new Error(`❌ Duplicate Error\n\n${data.message || 'Course with this code or slug already exists'}`);
        } else if (response.status === 401 || response.status === 403) {
          throw new Error('❌ Authentication Error\n\nYou are not authorized to create courses. Please log in again.');
        } else {
          throw new Error(data.message || 'Failed to create course');
        }
      }
    } catch (error) {
      console.error(`Error ${isEditMode ? 'updating' : 'creating'} course:`, error);
      
      // Display user-friendly error message
      if (error.message.includes('fetch')) {
        alert('❌ Network Error\n\nUnable to connect to the server. Please check your internet connection and try again.');
      } else {
        alert(`❌ Error ${isEditMode ? 'Updating' : 'Creating'} Course\n\n${error.message}`);
      }
    } finally {
      setActionLoading(null);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleOpenEnrollmentModal = () => {
    setEnrollmentFormData({
      user_id: '',
      course_id: '',
      enrollment_source: 'direct',
      status: 'active',
      payment_status: 'pending',
      payment_amount: 0,
      notes: ''
    });
    setUserSearchQuery('');
    setCourseSearchQuery('');
    setSelectedUserName('');
    setSelectedCourseName('');
    setShowEnrollmentModal(true);
  };

  const handleUserSearch = async (query) => {
    setUserSearchQuery(query);
    if (query.length < 2) {
      setUserSearchResults([]);
      setShowUserDropdown(false);
      return;
    }

    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/users`, {
        headers: {
          [TOKEN_HEADER]: generateToken(),
        },
      });
      const data = await response.json();
      if (data.success) {
        const filtered = data.data.filter(user => 
          user.full_name?.toLowerCase().includes(query.toLowerCase()) ||
          user.email?.toLowerCase().includes(query.toLowerCase())
        );
        setUserSearchResults(filtered.slice(0, 10));
        setShowUserDropdown(true);
      }
    } catch (error) {
      console.error('Error searching users:', error);
    }
  };

  const handleCourseSearch = async (query) => {
    setCourseSearchQuery(query);
    if (query.length < 2) {
      setCourseSearchResults([]);
      setShowCourseDropdown(false);
      return;
    }

    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/courses`, {
        headers: {
          [TOKEN_HEADER]: generateToken(),
        },
      });
      const data = await response.json();
      if (data.success) {
        const filtered = data.data.filter(course => 
          course.title?.toLowerCase().includes(query.toLowerCase()) ||
          course.course_code?.toLowerCase().includes(query.toLowerCase())
        );
        setCourseSearchResults(filtered.slice(0, 10));
        setShowCourseDropdown(true);
      }
    } catch (error) {
      console.error('Error searching courses:', error);
    }
  };

  const handleSelectUser = (user) => {
    console.log('Selected user:', user);
    console.log('User ID:', user.id);
    setEnrollmentFormData(prev => {
      const updated = { ...prev, user_id: user.id };
      console.log('Updated enrollment form data:', updated);
      return updated;
    });
    setSelectedUserName(user.full_name || user.email);
    setUserSearchQuery(user.full_name || user.email);
    setShowUserDropdown(false);
  };

  const handleSelectCourse = (course) => {
    console.log('Selected course:', course);
    console.log('Course ID:', course.id);
    setEnrollmentFormData(prev => {
      const updated = { ...prev, course_id: course.id };
      console.log('Updated enrollment form data:', updated);
      return updated;
    });
    setSelectedCourseName(`${course.course_code} - ${course.title}`);
    setCourseSearchQuery(`${course.course_code} - ${course.title}`);
    setShowCourseDropdown(false);
  };

  const handleCloseEnrollmentModal = () => {
    setShowEnrollmentModal(false);
    setEnrollmentFormData({
      user_id: '',
      course_id: '',
      enrollment_source: 'direct',
      status: 'active',
      payment_status: 'pending',
      payment_amount: 0,
      notes: ''
    });
  };

  const handleEnrollmentFormChange = (field, value) => {
    setEnrollmentFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleEnrollLearner = async () => {
    try {
      setActionLoading('enroll-learner');

      if (!enrollmentFormData.user_id || !enrollmentFormData.course_id) {
        alert('Please fill in all required fields');
        return;
      }

      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/enrollments/course/${enrollmentFormData.course_id}/enroll`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
        body: JSON.stringify({
          learners: [{
            user_id: parseInt(enrollmentFormData.user_id),
            enrollment_source: enrollmentFormData.enrollment_source,
            status: enrollmentFormData.status,
            payment_status: enrollmentFormData.payment_status,
            payment_amount: parseFloat(enrollmentFormData.payment_amount) || 0,
            notes: enrollmentFormData.notes
          }]
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        alert('Learner enrolled successfully!');
        handleCloseEnrollmentModal();
        fetchEnrollments(); // Refresh enrollments list
      } else {
        throw new Error(data.error || 'Failed to enroll learner');
      }
    } catch (error) {
      console.error('Error enrolling learner:', error);
      alert(`Error: ${error.message}`);
    } finally {
      setActionLoading(null);
    }
  };

  // Export Events as Excel Handler
  const handleExportEventsExcel = () => {
    if (!events || events.length === 0) {
      alert('No events to export.');
      return;
    }
    const columns = [
      'id', 'title', 'description', 'start_datetime', 'end_datetime', 'timezone', 'location_type',
      'location_name', 'address', 'city', 'state', 'country', 'postal_code', 'latitude', 'longitude',
      'location_url', 'organizer_id', 'category_id', 'status', 'is_featured', 'is_public',
      'max_attendees', 'registration_deadline', 'image_url', 'thumbnail_url', 'tags',
      'created_at', 'updated_at', 'category_name', 'organizer_name'
    ];
    const data = events.map(event => {
      const row = {};
      columns.forEach(col => { row[col] = event[col] ?? ''; });
      return row;
    });
    const ws = XLSX.utils.json_to_sheet(data, { header: columns });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Events');
    XLSX.writeFile(wb, 'events-export.xlsx');
  };

  // Import Events from Excel Handler
  const handleImportEventsExcel = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      setActionLoading('importing-events');
      const reader = new FileReader();
      
      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          if (jsonData.length === 0) {
            alert('No data found in the Excel file.');
            setActionLoading(null);
            return;
          }

          let created = 0;
          let updated = 0;
          let errors = [];

          for (const row of jsonData) {
            const eventId = parseInt(row.id);
            const eventPayload = {
              title: row.title || '',
              description: row.description || '',
              start_datetime: row.start_datetime || '',
              end_datetime: row.end_datetime || '',
              timezone: row.timezone || 'UTC',
              location_type: row.location_type || 'physical',
              location_name: row.location_name || '',
              address: row.address || '',
              city: row.city || '',
              state: row.state || '',
              country: row.country || '',
              postal_code: row.postal_code || '',
              latitude: row.latitude !== undefined && row.latitude !== '' && row.latitude !== null ? parseFloat(row.latitude) : 0,
              longitude: row.longitude !== undefined && row.longitude !== '' && row.longitude !== null ? parseFloat(row.longitude) : 0,
              location_url: row.location_url || '',
              organizer_id: row.organizer_id ? parseInt(row.organizer_id) : 1,
              category_id: row.category_id ? parseInt(row.category_id) : null,
              status: row.status || 'draft',
              is_featured: row.is_featured === true || row.is_featured === 'true' || row.is_featured === 1,
              is_public: row.is_public !== false && row.is_public !== 'false' && row.is_public !== 0,
              max_attendees: row.max_attendees ? parseInt(row.max_attendees) : null,
              registration_deadline: row.registration_deadline || null,
              image_url: row.image_url || '',
              thumbnail_url: row.thumbnail_url || '',
              tags: row.tags || ''
            };

            try {
              if (eventId === -1 || isNaN(eventId)) {
                // Create new event
                const response = await fetch(`${API_ENDPOINTS.BASE_URL}/events`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    [TOKEN_HEADER]: generateToken(),
                  },
                  body: JSON.stringify(eventPayload)
                });
                const result = await response.json();
                if (response.ok && result.success) {
                  created++;
                } else {
                  errors.push(`Row ${row.id || 'new'}: ${result.error || 'Failed to create'}`);
                }
              } else if (eventId > 0) {
                // Update existing event
                const response = await fetch(`${API_ENDPOINTS.BASE_URL}/events/${eventId}`, {
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    [TOKEN_HEADER]: generateToken(),
                  },
                  body: JSON.stringify(eventPayload)
                });
                const result = await response.json();
                if (response.ok && result.success) {
                  updated++;
                } else {
                  errors.push(`Row ${eventId}: ${result.error || 'Failed to update'}`);
                }
              }
            } catch (err) {
              errors.push(`Row ${row.id || 'unknown'}: ${err.message}`);
            }
          }

          // Show results
          let message = `Import completed!\n\nCreated: ${created}\nUpdated: ${updated}`;
          if (errors.length > 0) {
            message += `\n\nErrors (${errors.length}):\n${errors.slice(0, 5).join('\n')}`;
            if (errors.length > 5) {
              message += `\n... and ${errors.length - 5} more errors`;
            }
          }
          alert(message);
          
          // Refresh events list
          fetchEvents();
        } catch (err) {
          console.error('Error parsing Excel:', err);
          alert('Error parsing Excel file: ' + err.message);
        } finally {
          setActionLoading(null);
          // Reset file input
          event.target.value = '';
        }
      };

      reader.readAsArrayBuffer(file);
    } catch (err) {
      console.error('Error importing events:', err);
      alert('Error importing events: ' + err.message);
      setActionLoading(null);
    }
  };

  const handleJobCSVImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setJobImporting(true);
    setJobCSVError('');
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const data = evt.target.result;
        console.log('CSV file data:', data);
        const workbook = XLSX.read(data, { type: 'binary' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet);
        // Helper to format date as yyyy-mm-dd
        const formatDate = (val) => {
          if (!val) return '';
          const d = new Date(val);
          if (isNaN(d)) return '';
          return d.toISOString().slice(0, 10);
        };
        // Map CSV columns to job fields
        const jobsToImport = rows.map(row => ({
          title: row.title || row.Title || '',
          description: row.description || row.Description || '',
          company: row.company || row.Company || '',
          location: row.location || row.Location || '',
          primaryskills: row.primaryskills || row.PrimarySkills || '',
          secondskills: row.secondskills || row.SecondSkills || '',
          createdon: formatDate(row.createdon || row.CreatedOn),
          applyby: formatDate(row.applyby || row.ApplyBy),
          isactive: row.isactive !== undefined ? row.isactive : true
        }));
        // Bulk import jobs
        Promise.all(jobsToImport.map(job =>
          fetch(`${API_ENDPOINTS.BASE_URL}/lwt/jobs`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', [TOKEN_HEADER]: generateToken() },
            body: JSON.stringify(job)
          })
        )).then(() => {
          setJobImporting(false);
          fetchJobs();
        });
      } catch (err) {
        setJobCSVError('Failed to import jobs. Invalid file format.');
        setJobImporting(false);
      }
    };
    reader.readAsBinaryString(file);
  };

  const renderDashboard = () => (
    <div>
      {/* Hero strip */}
      <div style={{
        background: '#1A2A38',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        padding: '32px 28px 28px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div className="ep-hero-glow" aria-hidden="true" style={{ top: -160, right: -120 }} />
        <h1 className="ep-hero-title" style={{ fontSize: '32px', marginBottom: '8px' }}>
          Welcome to <span className="ep-red">LWT Admin</span>
        </h1>
        <p className="ep-hero-sub" style={{ marginBottom: '24px' }}>
          Manage leads, events, courses, enrollments and all platform content from one place.
        </p>
        <div className="ep-hero-actions">
          <button className="ep-btn-primary" onClick={() => setActiveSection('leads')}>View Leads →</button>
          <button className="ep-btn-ghost" onClick={() => setActiveSection('events')}>📅 Events</button>
          <button className="ep-btn-ghost" onClick={() => setActiveSection('courses')}>📚 Courses</button>
          <button className="ep-btn-ghost" onClick={() => setActiveSection('surveys')}>📋 Surveys</button>
        </div>
      </div>

      {/* Stats grid */}
      <div style={{ padding: '28px' }}>
        <div className="ep-stats-grid" style={{ marginBottom: '28px' }}>
          {[
            { n: dashboardStats?.leads?.total || 0,            l: 'Leads',            sub: `${dashboardStats?.leads?.new_today || 0} new today`,      section: 'leads' },
            { n: dashboardStats?.courses?.total || 0,          l: 'Courses',          sub: `${dashboardStats?.courses?.published || 0} published`,    section: 'courses' },
            { n: dashboardStats?.enrollments?.total || 0,      l: 'Enrollments',      sub: `${dashboardStats?.enrollments?.active || 0} active`,       section: 'enrollments' },
            { n: dashboardStats?.users?.total || 0,            l: 'Users',            sub: `${dashboardStats?.users?.students || 0} students`,         section: 'users' },
          ].map(({ n, l, sub, section }) => (
            <div
              key={section}
              className="ep-stat-card"
              onClick={() => setActiveSection(section)}
              style={{ cursor: 'pointer', transition: 'transform 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-3px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'none'}
            >
              <div className="ep-stat-n">{n}</div>
              <div className="ep-stat-l">{l}</div>
              <div style={{ fontSize: '11px', color: '#9DB0BF', marginTop: '4px' }}>{sub}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '10px' }}>
          {[
            { icon: '📅', label: 'Events',                  section: 'events',             sub: `${dashboardStats?.events?.upcoming || 0} upcoming` },
            { icon: '📝', label: 'Quizzes',                 section: 'quizzes',            sub: 'Assessment management' },
            { icon: '🏷️', label: 'Event Categories',        section: 'eventCategories',    sub: `${dashboardStats?.eventCategories?.active || 0} active` },
            { icon: '💼', label: 'Jobs',                    section: 'jobs',               sub: 'Job board' },
            { icon: '📄', label: 'Job Applications',        section: 'jobApplications',    sub: 'Applicants' },
            { icon: '📨', label: 'External Event Leads',    section: 'eventRegistrations', sub: 'Lead imports' },
            { icon: '⭐', label: 'Feedbacks',               section: 'feedbacks',          sub: 'Event reviews' },
            { icon: '🖼️', label: 'Past Event Images',       section: 'pastEventImages',    sub: 'Media library' },
            { icon: '📋', label: 'Surveys',                 section: 'surveys',            sub: 'Survey manager' },
          ].map(({ icon, label, section, sub }) => (
            <div
              key={section}
              onClick={() => setActiveSection(section)}
              style={{
                background: '#1A2A38',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '14px',
                padding: '18px 16px',
                cursor: 'pointer',
                transition: 'border-color 0.15s, transform 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(222,44,30,0.5)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; e.currentTarget.style.transform = 'none'; }}
            >
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>{icon}</div>
              <div style={{ fontSize: '13px', fontWeight: 700, color: '#E8EEF3', marginBottom: '3px' }}>{label}</div>
              <div style={{ fontSize: '11px', color: '#9DB0BF' }}>{sub}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderCoursesSection = () => (
    <div className="section-content">
      <div className="section-header">
        <h2>Courses Management</h2>
        <div className="section-actions">
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginRight: '15px' }}>
            <button 
              className={`action-btn ${courseViewMode === 'list' ? 'action-btn-primary' : 'action-btn-secondary'}`}
              onClick={() => setCourseViewMode('list')}
              title="List View"
            >
              📋
            </button>
            <button 
              className={`action-btn ${courseViewMode === 'grid' ? 'action-btn-primary' : 'action-btn-secondary'}`}
              onClick={() => setCourseViewMode('grid')}
              title="Grid View"
            >
              ⊞
            </button>
          </div>
          <button className="action-btn action-btn-primary" onClick={handleOpenCourseModal}>➕ Add New Course</button>
          <button className="action-btn action-btn-secondary" onClick={fetchCourses}>🔄 Refresh</button>
          <button className="action-btn action-btn-secondary">📊 View Statistics</button>
        </div>
      </div>

      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <p>Loading courses...</p>
        </div>
      ) : courses.length === 0 ? (
        <div className="placeholder-content">
          <div className="placeholder-icon">📚</div>
          <h3>No Courses Found</h3>
          <p>Start by creating your first course.</p>
          <button className="action-btn action-btn-primary" style={{ marginTop: '20px' }}>➕ Create First Course</button>
        </div>
      ) : courseViewMode === 'grid' ? (
        <div className="courses-grid">
          {courses.map((course) => (
            <div key={course.id} className="course-grid-card">
              <div className="course-thumbnail">
                {course.thumbnail_url ? (
                  <img src={course.thumbnail_url} alt={course.title} />
                ) : (
                  <div className="course-thumbnail-placeholder">
                    <span>📚</span>
                  </div>
                )}
                <div className="course-badges">
                  {course.is_featured && (
                    <span className="badge" style={{ backgroundColor: '#ffc107', color: '#000' }}>⭐ Featured</span>
                  )}
                  <span className={`badge ${course.is_published ? 'badge-success' : 'badge-warning'}`}>
                    {course.is_published ? '✓ Published' : '⏳ Draft'}
                  </span>
                </div>
              </div>
              <div className="course-card-content">
                <div className="course-card-header">
                  <span className="badge badge-info">{course.course_code}</span>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
                    {course.price_usd > 0 && <span className="course-price" style={{ fontSize: '13px' }}>${course.price_usd.toFixed(2)}</span>}
                    {course.price_inr > 0 && <span className="course-price" style={{ fontSize: '11px', color: '#666' }}>₹{course.price_inr.toFixed(0)}</span>}
                    {course.price_aud > 0 && <span className="course-price" style={{ fontSize: '11px', color: '#666' }}>A${course.price_aud.toFixed(2)}</span>}
                    {!course.price_usd && !course.price_inr && !course.price_aud && course.price && <span className="course-price">${course.price.toFixed(2)}</span>}
                    {!course.price_usd && !course.price_inr && !course.price_aud && !course.price && <span className="course-price">Free</span>}
                  </div>
                </div>
                <h3 className="course-card-title">{course.title}</h3>
                {course.short_description && (
                  <p className="course-card-description">
                    {course.short_description.substring(0, 100)}{course.short_description.length > 100 ? '...' : ''}
                  </p>
                )}
                <div className="course-card-meta">
                  <span title="Category">📁 {course.category || 'N/A'}</span>
                  <span title="Level">📊 {course.level || 'N/A'}</span>
                  <span title="Duration">⏱️ {course.duration_hours ? `${course.duration_hours}h` : 'N/A'}</span>
                </div>
                <div className="course-card-footer">
                  <div className="course-card-date">
                    Created: {new Date(course.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </div>
                  <div className="course-card-actions">
                    <button
                      className="action-btn action-btn-email"
                      onClick={() => handleEditCourse(course)}
                      title="Edit Course"
                    >
                      ✏️
                    </button>
                    <button
                      className="action-btn action-btn-status"
                      onClick={() => handleManageModules(course)}
                      title="Manage Modules"
                    >
                      📑
                    </button>
                    <button
                      className="action-btn action-btn-delete"
                      title="Delete Course"
                    >
                      🗑️
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Thumbnail</th>
                <th>ID</th>
                <th>Code</th>
                <th>Title</th>
                <th>Category</th>
                <th>Level</th>
                <th>Price (INR)</th>
                <th>Price (USD)</th>
                <th>Price (AUD)</th>
                <th>Status</th>
                <th>Duration</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {courses.map((course) => (
                <tr key={course.id}>
                  <td>
                    <div style={{ width: '60px', height: '60px', borderRadius: '8px', overflow: 'hidden', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {course.thumbnail_url ? (
                        <img src={course.thumbnail_url} alt={course.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <span style={{ fontSize: '24px' }}>📚</span>
                      )}
                    </div>
                  </td>
                  <td>{course.id}</td>
                  <td><span className="badge badge-info">{course.course_code}</span></td>
                  <td>
                    <div style={{ maxWidth: '250px' }}>
                      <strong>{course.title}</strong>
                      {course.short_description && (
                        <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                          {course.short_description.substring(0, 60)}{course.short_description.length > 60 ? '...' : ''}
                        </div>
                      )}
                    </div>
                  </td>
                  <td>{course.category || 'N/A'}</td>
                  <td><span className="badge badge-info">{course.level || 'N/A'}</span></td>
                  <td>
                    {course.price > 0 ? (
                      <span style={{ fontWeight: '600' }}>₹{course.price.toFixed(2)}</span>
                    ) : (
                      <span style={{ color: '#999' }}>-</span>
                    )}
                  </td>
                  <td>
                    {course.price_usd > 0 ? (
                      <span style={{ fontWeight: '600' }}>${course.price_usd.toFixed(2)}</span>
                    ) : (
                      <span style={{ color: '#999' }}>-</span>
                    )}
                  </td>
                  <td>
                    {course.price_aud > 0 ? (
                      <span style={{ fontWeight: '600' }}>A${course.price_aud.toFixed(2)}</span>
                    ) : (
                      <span style={{ color: '#999' }}>-</span>
                    )}
                  </td>
                  <td>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <span className={`badge ${course.is_published ? 'badge-success' : 'badge-warning'}`}>
                        {course.is_published ? '✓ Published' : '⏳ Draft'}
                      </span>
                      {course.is_featured && (
                        <span className="badge" style={{ backgroundColor: '#ffc107', color: '#000' }}>⭐ Featured</span>
                      )}
                    </div>
                  </td>
                  <td>{course.duration_hours ? `${course.duration_hours}h` : 'N/A'}</td>
                  <td>{new Date(course.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn action-btn-email"
                        onClick={() => handleEditCourse(course)}
                        title="Edit Course"
                      >
                        ✏️
                      </button>
                      <button
                        className="action-btn action-btn-status"
                        onClick={() => handleManageModules(course)}
                        title="Manage Modules"
                      >
                        📑
                      </button>
                      <button
                        className="action-btn action-btn-delete"
                        title="Delete Course"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  const renderEnrollmentsSection = () => (
    <div className="section-content">
      <div className="section-header">
        <h2>Enrollments Management</h2>
        <div className="section-actions">
          <button className="action-btn action-btn-primary" onClick={handleOpenEnrollmentModal}>➕ Enroll Learner</button>
          <button className="action-btn action-btn-secondary" onClick={fetchEnrollments}>🔄 Refresh</button>
          <button className="action-btn action-btn-secondary">📊 View Statistics</button>
        </div>
      </div>

      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <p>Loading enrollments...</p>
        </div>
      ) : enrollments.length === 0 ? (
        <div className="placeholder-content">
          <div className="placeholder-icon">👥</div>
          <h3>No Enrollments Found</h3>
          <p>No learners are enrolled in any courses yet.</p>
          <button className="action-btn action-btn-primary" style={{ marginTop: '20px' }}>➕ Enroll First Learner</button>
        </div>
      ) : (
        <div className="table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>User</th>
                <th>Course</th>
                <th>Enrolled Date</th>
                <th>Status</th>
                <th>Progress</th>
                <th>Payment</th>
                <th>Last Accessed</th>
                <th>Completed</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {enrollments.map((enrollment) => (
                <tr key={enrollment.id}>
                  <td>{enrollment.id}</td>
                  <td>
                    <div>
                      <strong>{enrollment.first_name} {enrollment.last_name}</strong>
                      <div style={{ fontSize: '12px', color: '#666' }}>{enrollment.email}</div>
                    </div>
                  </td>
                  <td>
                    <div>
                      <strong>{enrollment.course_title || `Course ID: ${enrollment.course_id}`}</strong>
                      {enrollment.course_code && (
                        <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>{enrollment.course_code}</div>
                      )}
                    </div>
                  </td>
                  <td>{new Date(enrollment.enrollment_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                  <td>
                    <span className={`badge ${
                      enrollment.status === 'active' ? 'badge-info' :
                      enrollment.status === 'completed' ? 'badge-success' :
                      enrollment.status === 'dropped' ? 'badge-warning' :
                      'badge-secondary'
                    }`}>
                      {enrollment.status}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{
                        flex: 1, 
                        height: '6px', 
                        backgroundColor: '#e0e0e0', 
                        borderRadius: '3px',
                        overflow: 'hidden'
                      }}>
                        <div style={{
                          width: `${enrollment.progress_percentage || 0}%`,
                          height: '100%',
                          backgroundColor: '#4caf50',
                          borderRadius: '3px'
                        }}></div>
                      </div>
                      <span style={{ fontSize: '12px', fontWeight: '600', minWidth: '35px' }}>
                        {enrollment.progress_percentage || 0}%
                      </span>
                    </div>
                  </td>
                  <td>
                    <span className={`badge ${
                      enrollment.payment_status === 'paid' ? 'badge-success' :
                      enrollment.payment_status === 'free' ? 'badge-info' :
                      'badge-warning'
                    }`}>
                      {enrollment.payment_status}
                    </span>
                    {enrollment.payment_amount > 0 && (
                      <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                        ${enrollment.payment_amount}
                      </div>
                    )}
                  </td>
                  <td>
                    {enrollment.last_accessed_at ? 
                      new Date(enrollment.last_accessed_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) :
                      'Never'
                    }
                  </td>
                  <td>
                    {enrollment.completed_at ? (
                      <span className="badge badge-success">
                        ✓ {new Date(enrollment.completed_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                      </span>
                    ) : (
                      <span style={{ color: '#999', fontSize: '12px' }}>-</span>
                    )}
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn action-btn-email"
                        title="Edit Enrollment"
                      >
                        ✏️
                      </button>
                      <button
                        className="action-btn action-btn-status"
                        title="View Details"
                      >
                        👁️
                      </button>
                      <button
                        className="action-btn action-btn-delete"
                        title="Delete Enrollment"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  const renderUsersSection = () => (
    <div className="section-content">
      <div className="section-header">
        <h2>Users Management</h2>
        <div className="section-actions">
          <button className="action-btn action-btn-primary">➕ Add New User</button>
          <button className="action-btn action-btn-secondary" onClick={fetchUsers}>🔄 Refresh</button>
          <button className="action-btn action-btn-secondary">📊 View Statistics</button>
        </div>
      </div>

      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <p>Loading users...</p>
        </div>
      ) : users.length === 0 ? (
        <div className="placeholder-content">
          <div className="placeholder-icon">🧑</div>
          <h3>No Users Found</h3>
          <p>Start by creating your first user.</p>
          <button className="action-btn action-btn-primary" style={{ marginTop: '20px' }}>➕ Create First User</button>
        </div>
      ) : (
        <div className="table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Username</th>
                <th>Role</th>
                <th>Phone</th>
                <th>Status</th>
                <th>Email Verified</th>
                <th>Last Login</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {user.profile_picture ? (
                        <img 
                          src={user.profile_picture} 
                          alt={user.first_name}
                          style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover' }}
                        />
                      ) : (
                        <div style={{ 
                          width: '32px', 
                          height: '32px', 
                          borderRadius: '50%', 
                          backgroundColor: '#667eea',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: '600',
                          fontSize: '14px'
                        }}>
                          {user.first_name?.charAt(0)}{user.last_name?.charAt(0)}
                        </div>
                      )}
                      <div>
                        <strong>{user.first_name} {user.last_name}</strong>
                      </div>
                    </div>
                  </td>
                  <td>{user.email}</td>
                  <td><span className="badge badge-info">{user.username}</span></td>
                  <td>
                    <span className={`badge ${
                      user.role === 'admin' ? 'badge-danger' :
                      user.role === 'instructor' ? 'badge-warning' :
                      'badge-info'
                    }`}>
                      {user.role}
                    </span>
                  </td>
                  <td>{user.phone || '-'}</td>
                  <td>
                    <span className={`badge ${
                      user.is_active ? 'badge-success' : 'badge-secondary'
                    }`}>
                      {user.is_active ? '✓ Active' : '✗ Inactive'}
                    </span>
                  </td>
                  <td>
                    {user.is_email_verified ? (
                      <span className="badge badge-success">✓ Verified</span>
                    ) : (
                      <span className="badge badge-warning">⏳ Pending</span>
                    )}
                  </td>
                  <td>
                    {user.last_login ? 
                      new Date(user.last_login).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) :
                      'Never'
                    }
                  </td>
                  <td>{new Date(user.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn action-btn-email"
                        title="Edit User"
                      >
                        ✏️
                      </button>
                      <button
                        className="action-btn action-btn-status"
                        title="Reset Password"
                      >
                        🔑
                      </button>
                      <button
                        className="action-btn action-btn-delete"
                        title="Delete User"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  // Event Management Handlers
  const handleOpenEventModal = () => {
    setIsEditMode(false);
    setEditingEventId(null);
    setSelectedEvent(null);
    setShowEventModal(true);
    fetchEventCategories();
  };

  const handleEditEvent = (event) => {
    setIsEditMode(true);
    setEditingEventId(event.id);
    
    // Event object already has the correct field names from API
    // Just pass it directly to EventForm
    setSelectedEvent(event);
    setShowEventModal(true);
    fetchEventCategories();
  };

  const handleCloseEventModal = () => {
    setShowEventModal(false);
    setIsEditMode(false);
    setEditingEventId(null);
    setSelectedEvent(null);
  };

  const handleEventSave = async (submitData) => {
    try {
      setActionLoading('event-save');
      
      // Prepare data for API - map EventForm fields to API fields
      const eventData = {
        title: submitData.title.trim(),
        description: submitData.description.trim() || null,
        category_id: submitData.category_id || null,
        start_datetime: submitData.start_datetime || null,
        end_datetime: submitData.end_datetime || null,
        timezone: submitData.timezone || 'UTC',
        location_type: submitData.location_type,
        location_name: submitData.location_name?.trim() || null,
        address: submitData.address?.trim() || null,
        city: submitData.city?.trim() || null,
        state: submitData.state?.trim() || null,
        country: submitData.country?.trim() || null,
        postal_code: submitData.postal_code?.trim() || null,
        location_url: submitData.location_url?.trim() || 'https://maps.google.com?city=bangalore',
        latitude: submitData.latitude !== null && submitData.latitude !== undefined ? submitData.latitude : 0.0,
        longitude: submitData.longitude !== null && submitData.longitude !== undefined ? submitData.longitude : 0.0,
        organizer_id: submitData.organizer_id || 1,
        max_attendees: submitData.max_attendees || null,
        registration_deadline: submitData.registration_deadline || null,
        image_url: submitData.image_url?.trim() || null,
        thumbnail_url: submitData.thumbnail_url?.trim() || null,
        status: submitData.status || 'draft',
        is_featured: submitData.is_featured || false,
        is_public: submitData.is_public !== undefined ? submitData.is_public : true,
        tags: submitData.tags?.trim() || null,
        prices: Array.isArray(submitData.prices)
          ? submitData.prices.map((item) => ({
              currency: String(item.currency || '').trim().toUpperCase(),
              price: Number(item.price),
              isenabled: item.isenabled !== false
            }))
              .filter((item) => item.currency && Number.isFinite(item.price) && item.price >= 0)
          : []
      };

      const isEditing = isEditMode && editingEventId;
      const url = isEditing 
        ? `${API_ENDPOINTS.BASE_URL}/events/${editingEventId}`
        : `${API_ENDPOINTS.BASE_URL}/events`;
      const method = isEditing ? 'PUT' : 'POST';

      console.log(`${isEditing ? 'Updating' : 'Creating'} event with data:`, eventData);

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
        body: JSON.stringify(eventData)
      });

      const data = await response.json();
      
      if (response.ok && data.success) {
        const action = isEditing ? 'updated' : 'created';
        alert(`✅ Success!\n\nEvent "${eventData.title}" has been ${action} successfully.\n\nEvent ID: ${data.data?.id || editingEventId || 'N/A'}`);
        handleCloseEventModal();
        fetchEvents();
      } else {
        // Handle validation errors
        if (response.status === 400 && data.errors) {
          const errorMessages = Object.entries(data.errors)
            .map(([field, message]) => `• ${field}: ${message}`)
            .join('\n');
          throw new Error(`Validation Failed:\n\n${errorMessages}`);
        } else if (response.status === 401 || response.status === 403) {
          throw new Error('❌ Authentication Error\n\nYou are not authorized to manage events. Please log in again.');
        } else {
          throw new Error(data.message || 'Failed to save event');
        }
      }
    } catch (error) {
      console.error(`Error ${isEditMode ? 'updating' : 'creating'} event:`, error);
      
      if (error.message.includes('fetch')) {
        alert('❌ Network Error\n\nUnable to connect to the server. Please check your internet connection and try again.');
      } else {
        alert(`❌ Error ${isEditMode ? 'Updating' : 'Creating'} Event\n\n${error.message}`);
      }
    } finally {
      setActionLoading(null);
    }
  };

  const handleDeleteEvent = async (eventId, eventTitle) => {
    if (!window.confirm(`Are you sure you want to delete the event "${eventTitle}"?\n\nThis will soft delete the event and all related RSVPs and comments.`)) {
      return;
    }

    try {
      setActionLoading(`event-delete-${eventId}`);
      
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/events/${eventId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        }
      });

      const data = await response.json();
      
      if (response.ok && data.success) {
        alert(`✅ Success!\n\nEvent "${eventTitle}" has been deleted successfully.`);
        fetchEvents();
      } else {
        throw new Error(data.message || 'Failed to delete event');
      }
    } catch (error) {
      console.error('Error deleting event:', error);
      alert(`❌ Error Deleting Event\n\n${error.message}`);
    } finally {
      setActionLoading(null);
    }
  };

  const handleManageRSVPs = async (event) => {
    // TODO: Implement RSVP management modal
    alert(`RSVP Management for "${event.title}"\n\nThis feature is coming soon!\n\nTotal RSVPs: ${event.going_count || 0} Going, ${event.interested_count || 0} Interested`);
  };

  // Invite Modal Handlers
  const handleOpenInviteModal = async (event) => {
    setInviteEvent(event);
    setSelectedInvitees(new Set());
    setInviteSearch('');
    setShowInviteModal(true);
    setInviteLoading(true);
    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/admin/event-registrations?limit=1000`, {
        headers: { [TOKEN_HEADER]: generateToken() },
      });
      const data = await response.json();
      if (data.success) {
        setInviteRegistrations(data.data);
      } else {
        setInviteRegistrations([]);
      }
    } catch (err) {
      console.error('Error fetching registrations for invite:', err);
      setInviteRegistrations([]);
    } finally {
      setInviteLoading(false);
    }
  };

  const handleCloseInviteModal = () => {
    setShowInviteModal(false);
    setInviteEvent(null);
    setInviteRegistrations([]);
    setSelectedInvitees(new Set());
    setInviteSearch('');
  };

  const handleToggleInvitee = (id) => {
    setSelectedInvitees(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const handleSelectAllInvitees = (filtered) => {
    if (filtered.every(r => selectedInvitees.has(r.id))) {
      setSelectedInvitees(new Set());
    } else {
      setSelectedInvitees(new Set(filtered.map(r => r.id)));
    }
  };

  const handleSendInvites = () => {
    // TODO: wire up email template and send logic
    alert(`Invites will be sent to ${selectedInvitees.size} recipient(s) for "${inviteEvent?.title}".\n\nEmail template integration coming soon.`);
  };

  // Event Categories Management Handlers
  const handleOpenCategoryModal = () => {
    setSelectedCategory(null);
    setIsEditingCategory(false);
    setCategoryFormData({
      name: '',
      slug: '',
      description: '',
      color: '#3B82F6',
      icon: '',
      is_active: true
    });
    setShowCategoryModal(true);
  };

  const handleEditCategory = (category) => {
    setSelectedCategory(category);
    setIsEditingCategory(true);
    setCategoryFormData({
      name: category.name || '',
      slug: category.slug || '',
      description: category.description || '',
      color: category.color || '#3B82F6',
      icon: category.icon || '',
      is_active: category.is_active !== undefined ? category.is_active : true
    });
    setShowCategoryModal(true);
  };

  const handleCloseCategoryModal = () => {
    setShowCategoryModal(false);
    setSelectedCategory(null);
    setIsEditingCategory(false);
    setCategoryFormData({
      name: '',
      slug: '',
      description: '',
      color: '#3B82F6',
      icon: '',
      is_active: true
    });
  };

  const handleCategoryFormChange = (field, value) => {
    setCategoryFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Auto-generate slug from name if creating new category
    if (field === 'name' && !isEditingCategory) {
      const slug = value
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
      setCategoryFormData(prev => ({
        ...prev,
        slug: slug
      }));
    }
  };

  const handleCategorySave = async () => {
    try {
      setActionLoading('saving-category');
      
      // Validation
      if (!categoryFormData.name.trim()) {
        alert('Category name is required');
        setActionLoading(null);
        return;
      }
      
      if (!categoryFormData.slug.trim()) {
        alert('Category slug is required');
        setActionLoading(null);
        return;
      }

      const url = isEditingCategory 
        ? `${API_ENDPOINTS.BASE_URL}/events/categories/${selectedCategory.id}`
        : `${API_ENDPOINTS.BASE_URL}/events/categories`;
      
      const method = isEditingCategory ? 'PUT' : 'POST';
      
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
        body: JSON.stringify(categoryFormData)
      });

      const result = await response.json();

      if (response.ok && result.success) {
        alert(result.message || `Category ${isEditingCategory ? 'updated' : 'created'} successfully!`);
        handleCloseCategoryModal();
        fetchEventCategories();
        fetchDashboardStats();
      } else {
        alert(result.message || result.error || `Failed to ${isEditingCategory ? 'update' : 'create'} category`);
      }
    } catch (error) {
      console.error('Error saving category:', error);
      alert('An error occurred while saving the category');
    } finally {
      setActionLoading(null);
    }
  };

  const handleDeleteCategory = async (categoryId, categoryName) => {
    if (!window.confirm(`Are you sure you want to delete the category "${categoryName}"? This will set it as inactive.`)) {
      return;
    }

    try {
      setActionLoading(`deleting-category-${categoryId}`);
      
      const response = await fetch(
        `${API_ENDPOINTS.BASE_URL}/events/categories/${categoryId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            [TOKEN_HEADER]: generateToken(),
          }
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        alert('Category deleted successfully!');
        fetchEventCategories();
        fetchDashboardStats();
      } else {
        alert(result.message || result.error || 'Failed to delete category');
      }
    } catch (error) {
      console.error('Error deleting category:', error);
      alert('An error occurred while deleting the category');
    } finally {
      setActionLoading(null);
    }
  };

  const renderPastEventImagesSection = () => (
    <div className="section-content">
      <div className="section-header">
        <h2>Past Event Images</h2>
        <div className="section-actions">
          <button className="action-btn action-btn-secondary" onClick={() => { fetchPastEventImages(); fetchEventsForPastEventImages(); }}>
            🔄 Refresh
          </button>
        </div>
      </div>

      <form
        className="job-form"
        onSubmit={handlePastEventImageUpload}
        style={{ marginBottom: 24, background: '#f9f9f9', padding: 24, borderRadius: 12, boxShadow: '0 2px 8px #eee' }}
      >
        <h3 style={{ marginBottom: 20, fontWeight: 700, fontSize: 22 }}>Upload Past Event Image</h3>
        <p style={{ marginTop: -8, marginBottom: 18, color: '#64748b', fontSize: '14px' }}>
          Uploaded images are stored by the backend and can be reused across website pages and marketing assets.
        </p>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
          <select
            required
            value={pastEventImageFormData.event_id}
            onChange={(e) => setPastEventImageFormData((prev) => ({ ...prev, event_id: e.target.value }))}
            style={{ flex: '1 1 260px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16, backgroundColor: '#fff' }}
          >
            <option value="">
              {pastEventImageEventsLoading
                ? 'Loading events...'
                : pastEventImageEvents.length > 0
                  ? 'Select Event'
                  : 'No events available'}
            </option>
            {pastEventImageEvents.map((eventItem) => (
              <option key={eventItem.id} value={eventItem.id}>
                {eventItem.title || `Event ${eventItem.id}`}
              </option>
            ))}
          </select>
          <input
            required
            placeholder="Title"
            value={pastEventImageFormData.title}
            onChange={(e) => setPastEventImageFormData((prev) => ({ ...prev, title: e.target.value }))}
            style={{ flex: '1 1 260px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16 }}
          />
          <input
            type="date"
            value={pastEventImageFormData.event_date}
            onChange={(e) => setPastEventImageFormData((prev) => ({ ...prev, event_date: e.target.value }))}
            style={{ flex: '1 1 180px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16 }}
          />
          <input
            placeholder="Alt text"
            value={pastEventImageFormData.alt_text}
            onChange={(e) => setPastEventImageFormData((prev) => ({ ...prev, alt_text: e.target.value }))}
            style={{ flex: '1 1 260px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16 }}
          />
          <input
            placeholder="Tags (comma separated)"
            value={pastEventImageFormData.tags}
            onChange={(e) => setPastEventImageFormData((prev) => ({ ...prev, tags: e.target.value }))}
            style={{ flex: '1 1 260px', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: 8, fontSize: 16 }}
          />
        </div>

        <div style={{ marginTop: 14 }}>
          <label style={{ display: 'block', fontWeight: 600, marginBottom: 8 }}>Image File</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setPastEventImageFile(e.target.files?.[0] || null)}
            style={{ width: '100%', padding: '10px', border: '1.5px solid #d1d5db', borderRadius: 8 }}
          />
          {pastEventImageFile && (
            <small style={{ display: 'block', marginTop: 6, color: '#16a34a' }}>
              Selected: {pastEventImageFile.name}
            </small>
          )}
        </div>

        <div style={{ marginTop: 16, display: 'flex', gap: 12, alignItems: 'center' }}>
          <button
            className="action-btn"
            type="submit"
            disabled={pastEventImageUploading}
            style={{ background: '#e53935', color: '#fff', fontWeight: 700, fontSize: 18, padding: '12px 32px', borderRadius: 8, border: 'none', boxShadow: '0 2px 8px #fbb', cursor: 'pointer', transition: 'background 0.2s' }}
          >
            {pastEventImageUploading ? 'Uploading...' : 'Upload Image'}
          </button>
        </div>
      </form>

      <div style={{ overflowX: 'auto' }}>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Preview</th>
              <th>Event</th>
              <th>Title</th>
              <th>Event Date</th>
              <th>Tags</th>
              <th>Alt Text</th>
              <th>Uploaded On</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {pastEventImagesLoading ? (
              <tr><td colSpan="8">Loading images...</td></tr>
            ) : pastEventImages.length === 0 ? (
              <tr><td colSpan="8">No past event images found.</td></tr>
            ) : pastEventImages.map((item, index) => {
              const imageUrl = getPastEventImageUrl(item);
              const imageId = item.id || item.image_id;
              const itemEventId = item.event_id || item.eventid || '';
              const linkedEvent = pastEventImageEvents.find((evt) => String(evt.id) === String(itemEventId));
              const rowKey = imageId || imageUrl || `${itemEventId || 'event'}-${item.created_at || 'created'}-${index}`;
              return (
                <tr key={rowKey}>
                  <td>
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt={item.alt_text || item.title || 'Past event image'}
                        style={{ width: '72px', height: '54px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #ddd' }}
                      />
                    ) : (
                      <span style={{ color: '#999' }}>N/A</span>
                    )}
                  </td>
                  <td>
                    {linkedEvent ? (linkedEvent.title || `Event ${linkedEvent.id}`) : (itemEventId ? `ID: ${itemEventId}` : '-')}
                  </td>
                  <td>{item.title || 'Untitled'}</td>
                  <td>{item.event_date ? formatDate(item.event_date) : '-'}</td>
                  <td>{item.tags || '-'}</td>
                  <td style={{ maxWidth: '220px', whiteSpace: 'pre-wrap' }}>{item.alt_text || '-'}</td>
                  <td>{item.created_at ? formatDate(item.created_at) : '-'}</td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn action-btn-secondary"
                        onClick={() => handleCopyPastEventImageUrl(item)}
                        title="Copy Image URL"
                      >
                        🔗
                      </button>
                      <button
                        className="action-btn action-btn-delete"
                        onClick={() => handleDeletePastEventImage(imageId)}
                        disabled={!imageId || actionLoading === `past-image-${imageId}`}
                        title="Delete Image"
                      >
                        {actionLoading === `past-image-${imageId}` ? '⏳' : '🗑️'}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderQuizzesSection = () => <Quizzes />;

  // ═══════════════════════════════════════════════════════════════════════
  // SURVEYS
  // ═══════════════════════════════════════════════════════════════════════

  const fetchSurveys = async (page = 1, statusFilter = '') => {
    setSurveysLoading(true);
    try {
      const params = new URLSearchParams({ page, limit: 20 });
      if (statusFilter) params.set('status', statusFilter);
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/surveys?${params}`, {
        headers: { 'Content-Type': 'application/json', [TOKEN_HEADER]: generateToken() },
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setSurveys(data.data);
        setSurveysPagination(data.pagination);
        setSurveysPage(page);
      } else {
        throw new Error(data.message || 'Failed to fetch surveys');
      }
    } catch (err) {
      console.error('fetchSurveys error:', err);
      alert('Error loading surveys: ' + err.message);
    } finally {
      setSurveysLoading(false);
    }
  };

  const handleSurveysFilterChange = (status) => {
    setSurveysStatusFilter(status);
    fetchSurveys(1, status);
  };

  const handleOpenSurveyModal = (survey = null) => {
    if (survey) {
      // Load full survey detail (with questions) before opening form
      fetchSurveyDetail(survey.id);
    } else {
      setSelectedSurvey(null);
      setShowSurveyModal(true);
    }
  };

  const fetchSurveyDetail = async (id) => {
    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/surveys/${id}`, {
        headers: { 'Content-Type': 'application/json', [TOKEN_HEADER]: generateToken() },
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setSelectedSurvey(data.data);
        setShowSurveyModal(true);
      } else {
        throw new Error(data.message || 'Failed to load survey detail');
      }
    } catch (err) {
      alert('Error loading survey: ' + err.message);
    }
  };

  const handleCloseSurveyModal = () => {
    setShowSurveyModal(false);
    setSelectedSurvey(null);
  };

  const handleSurveySave = async (payload) => {
    setSurveySubmitting(true);
    try {
      const isEdit = !!selectedSurvey;
      const url    = isEdit
        ? `${API_ENDPOINTS.BASE_URL}/surveys/${selectedSurvey.id}`
        : `${API_ENDPOINTS.BASE_URL}/surveys`;
      const response = await fetch(url, {
        method: isEdit ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json', [TOKEN_HEADER]: generateToken() },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (response.ok && data.success) {
        handleCloseSurveyModal();
        fetchSurveys(surveysPage, surveysStatusFilter);
      } else {
        throw new Error(data.message || 'Failed to save survey');
      }
    } catch (err) {
      alert('Error saving survey: ' + err.message);
    } finally {
      setSurveySubmitting(false);
    }
  };

  const handleSurveyStatusChange = async (id, status) => {
    setSurveyActionLoading(`survey-${id}`);
    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/surveys/${id}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', [TOKEN_HEADER]: generateToken() },
        body: JSON.stringify({ status }),
      });
      const data = await response.json();
      if (response.ok && data.success) {
        fetchSurveys(surveysPage, surveysStatusFilter);
      } else {
        throw new Error(data.message || 'Failed to update status');
      }
    } catch (err) {
      alert('Error updating survey status: ' + err.message);
    } finally {
      setSurveyActionLoading(null);
    }
  };

  const handleSurveyDelete = async (id, title) => {
    if (!window.confirm(`Delete survey "${title}"?\n\nThis cannot be undone.`)) return;
    setSurveyActionLoading(`survey-${id}`);
    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/surveys/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', [TOKEN_HEADER]: generateToken() },
      });
      const data = await response.json();
      if (response.ok && data.success) {
        fetchSurveys(surveysPage, surveysStatusFilter);
      } else {
        throw new Error(data.message || 'Failed to delete survey');
      }
    } catch (err) {
      alert('Error deleting survey: ' + err.message);
    } finally {
      setSurveyActionLoading(null);
    }
  };

  const renderSurveysSection = () => (
    <div className="section-content">
      <div className="section-header">
        <h2>Surveys Management</h2>
        <div className="section-actions">
          <button
            className="action-btn action-btn-primary"
            onClick={() => handleOpenSurveyModal()}
          >
            ➕ New Survey
          </button>
        </div>
      </div>

      {/* Status filter */}
      <div className="surveys-filter-bar" style={{ marginTop: '16px' }}>
        {[
          { value: '',       label: 'All' },
          { value: 'draft',  label: '⏳ Draft' },
          { value: 'active', label: '✓ Active' },
          { value: 'closed', label: '✗ Closed' },
        ].map(f => (
          <button
            key={f.value}
            className={`surveys-filter-btn${surveysStatusFilter === f.value ? ' active' : ''}`}
            onClick={() => handleSurveysFilterChange(f.value)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <SurveysList
        surveys={surveys}
        loading={surveysLoading}
        actionLoading={surveyActionLoading}
        onEdit={handleOpenSurveyModal}
        onDelete={handleSurveyDelete}
        onStatusChange={handleSurveyStatusChange}
      />

      {/* Pagination */}
      {surveysPagination && surveysPagination.pages > 1 && (
        <div className="surveys-pagination">
          <span>
            Showing {surveys.length} of {surveysPagination.total} surveys
          </span>
          <div className="surveys-pagination-btns">
            <button
              onClick={() => fetchSurveys(surveysPage - 1, surveysStatusFilter)}
              disabled={surveysPage <= 1}
            >
              ← Prev
            </button>
            <span style={{ padding: '6px 12px', fontSize: '13px', color: '#374151' }}>
              {surveysPage} / {surveysPagination.pages}
            </span>
            <button
              onClick={() => fetchSurveys(surveysPage + 1, surveysStatusFilter)}
              disabled={surveysPage >= surveysPagination.pages}
            >
              Next →
            </button>
          </div>
        </div>
      )}

      {/* Create / Edit Modal */}
      {showSurveyModal && (
        <div className="modal-overlay" onClick={handleCloseSurveyModal}>
          <div
            className="modal-content"
            onClick={e => e.stopPropagation()}
            style={{ maxWidth: '880px', maxHeight: '92vh', overflowY: 'auto', padding: 0 }}
          >
            <SurveyForm
              survey={selectedSurvey}
              onSave={handleSurveySave}
              onClose={handleCloseSurveyModal}
              submitting={surveySubmitting}
            />
          </div>
        </div>
      )}
    </div>
  );

  // Export Events Handler
  const handleExportEvents = async () => {
    try {
      const response = await fetch('/api/events/export', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
        }
      });
      if (!response.ok) throw new Error('Failed to export events');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'events-export.json';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Error exporting events: ' + (err.message || err));
    }
  };

  const renderEventsSection = () => (
    <div className="section-content">
      <div className="section-header">
        <h2>Events Management</h2>
        <div className="section-actions">
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginRight: '15px' }}>
            <button 
              className={`action-btn ${eventViewMode === 'list' ? 'action-btn-primary' : 'action-btn-secondary'}`}
              onClick={() => setEventViewMode('list')}
              title="List View"
            >
              📋
            </button>
            <button 
              className={`action-btn ${eventViewMode === 'grid' ? 'action-btn-primary' : 'action-btn-secondary'}`}
              onClick={() => setEventViewMode('grid')}
              title="Grid View"
            >
              ⊞
            </button>
          </div>
          <button className="action-btn action-btn-primary" onClick={handleOpenEventModal}>➕ Add New Event</button>
          <button className="action-btn action-btn-secondary" onClick={fetchEvents}>🔄 Refresh</button>
          <button className="action-btn action-btn-secondary" onClick={handleExportEvents}>⬇️ Export Events (JSON)</button>
          <button className="action-btn action-btn-secondary" onClick={handleExportEventsExcel}>📊 Export Events (Excel)</button>
          <label className="action-btn action-btn-secondary" style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
            📥 Import Events (Excel)
            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={handleImportEventsExcel}
              style={{ display: 'none' }}
              disabled={actionLoading === 'importing-events'}
            />
          </label>
          {actionLoading === 'importing-events' && <span style={{ marginLeft: '10px' }}>⏳ Importing...</span>}
        </div>
      </div>

      <div className="filters-bar" style={{ marginBottom: '20px', display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
        <div className="filter-group" style={{ flex: '1', minWidth: '200px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '500' }}>Status</label>
          <select 
            className="form-control" 
            value={eventFilters.status} 
            onChange={(e) => setEventFilters(prev => ({ ...prev, status: e.target.value }))}
          >
            <option value="">All Statuses</option>
            <option value="draft">Draft</option>
            <option value="published">Published</option>
            <option value="completed">Completed</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>

        <div className="filter-group" style={{ flex: '1', minWidth: '200px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '500' }}>Location Type</label>
          <select 
            className="form-control" 
            value={eventFilters.location_type} 
            onChange={(e) => setEventFilters(prev => ({ ...prev, location_type: e.target.value }))}
          >
            <option value="">All Types</option>
            <option value="physical">Physical</option>
            <option value="virtual">Virtual</option>
            <option value="hybrid">Hybrid</option>
          </select>
        </div>

        <div className="filter-group" style={{ flex: '1', minWidth: '200px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '500' }}>Category</label>
          <select 
            className="form-control" 
            value={eventFilters.category_id} 
            onChange={(e) => setEventFilters(prev => ({ ...prev, category_id: e.target.value }))}
          >
            <option value="">All Categories</option>
            {eventCategories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
        </div>

        <div className="filter-group" style={{ flex: '0 0 auto', display: 'flex', alignItems: 'flex-end' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', paddingBottom: '5px' }}>
            <input 
              type="checkbox" 
              checked={eventFilters.upcoming_only}
              onChange={(e) => setEventFilters(prev => ({ ...prev, upcoming_only: e.target.checked }))}
            />
            <span style={{ fontSize: '14px', fontWeight: '500' }}>Upcoming Only</span>
          </label>
        </div>

        <div className="filter-group" style={{ flex: '0 0 auto', display: 'flex', alignItems: 'flex-end' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', paddingBottom: '5px' }}>
            <input 
              type="checkbox" 
              checked={eventFilters.featured_only}
              onChange={(e) => setEventFilters(prev => ({ ...prev, featured_only: e.target.checked }))}
            />
            <span style={{ fontSize: '14px', fontWeight: '500' }}>Featured Only</span>
          </label>
        </div>
      </div>

      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <p>Loading events...</p>
        </div>
      ) : events.length === 0 ? (
        <div className="placeholder-content">
          <div className="placeholder-icon">📅</div>
          <h3>No Events Found</h3>
          <p>Start by creating your first event.</p>
          <button className="action-btn action-btn-primary" style={{ marginTop: '20px' }} onClick={handleOpenEventModal}>➕ Create First Event</button>
        </div>
      ) : (
        <EventsList
          events={events}
          viewMode={eventViewMode}
          onEdit={handleEditEvent}
          onDelete={handleDeleteEvent}
          onManageRSVPs={handleManageRSVPs}
          onInvite={handleOpenInviteModal}
          actionLoading={actionLoading}
        />
      )}

      {showEventModal && (
        <div className="modal-overlay" onClick={handleCloseEventModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '900px', maxHeight: '90vh', overflowY: 'auto' }}>
            <EventForm
              event={selectedEvent}
              categories={eventCategories}
              onSave={handleEventSave}
              onClose={handleCloseEventModal}
            />
          </div>
        </div>
      )}

      {showInviteModal && inviteEvent && (
        <div className="modal-overlay" onClick={handleCloseInviteModal}>
          <div
            className="modal-content"
            onClick={e => e.stopPropagation()}
            style={{ maxWidth: '860px', width: '95vw', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}
          >
            {/* Header */}
            <div className="modal-header">
              <div>
                <h2>📨 Send Invites</h2>
                <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#6b7280', fontWeight: 400 }}>
                  {inviteEvent.title}
                </p>
              </div>
              <button className="modal-close" onClick={handleCloseInviteModal}>×</button>
            </div>

            {/* Search + selection summary */}
            <div style={{ padding: '16px 24px', borderBottom: '1px solid #e5e7eb', display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
              <input
                type="text"
                placeholder="Search by name, email or company…"
                value={inviteSearch}
                onChange={e => setInviteSearch(e.target.value)}
                style={{
                  flex: 1, minWidth: '200px', padding: '8px 12px',
                  border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', outline: 'none'
                }}
              />
              {(() => {
                const filtered = inviteRegistrations.filter(r => {
                  const q = inviteSearch.toLowerCase();
                  return !q ||
                    r.email?.toLowerCase().includes(q) ||
                    r.first_name?.toLowerCase().includes(q) ||
                    r.last_name?.toLowerCase().includes(q) ||
                    r.company_name?.toLowerCase().includes(q);
                });
                const allSelected = filtered.length > 0 && filtered.every(r => selectedInvitees.has(r.id));
                return (
                  <button
                    className="action-btn action-btn-secondary"
                    onClick={() => handleSelectAllInvitees(filtered)}
                    disabled={filtered.length === 0}
                  >
                    {allSelected ? '☐ Deselect All' : '☑ Select All'}
                  </button>
                );
              })()}
              {selectedInvitees.size > 0 && (
                <span style={{ fontSize: '13px', color: '#dc2626', fontWeight: 600 }}>
                  {selectedInvitees.size} selected
                </span>
              )}
            </div>

            {/* Registrations table */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '0 24px' }}>
              {inviteLoading ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>
                  ⏳ Loading registrations…
                </div>
              ) : inviteRegistrations.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>
                  <div style={{ fontSize: '32px', marginBottom: '8px' }}>📭</div>
                  <p style={{ margin: 0 }}>No event registrations found. Import leads first from the <strong>External Event Leads</strong> section.</p>
                </div>
              ) : (() => {
                const filtered = inviteRegistrations.filter(r => {
                  const q = inviteSearch.toLowerCase();
                  return !q ||
                    r.email?.toLowerCase().includes(q) ||
                    r.first_name?.toLowerCase().includes(q) ||
                    r.last_name?.toLowerCase().includes(q) ||
                    r.company_name?.toLowerCase().includes(q);
                });
                return filtered.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>
                    No results match your search.
                  </div>
                ) : (
                  <table className="admin-table" style={{ marginTop: '12px' }}>
                    <thead>
                      <tr>
                        <th style={{ width: '40px' }}></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Company</th>
                        <th>Job Title</th>
                        <th>Country</th>
                        <th>Form</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filtered.map(r => (
                        <tr
                          key={r.id}
                          onClick={() => handleToggleInvitee(r.id)}
                          style={{ cursor: 'pointer', background: selectedInvitees.has(r.id) ? '#fef2f2' : '' }}
                        >
                          <td onClick={e => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              checked={selectedInvitees.has(r.id)}
                              onChange={() => handleToggleInvitee(r.id)}
                              style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                            />
                          </td>
                          <td>
                            <strong>{[r.first_name, r.last_name].filter(Boolean).join(' ') || '—'}</strong>
                          </td>
                          <td>{r.email}</td>
                          <td>{r.company_name || '—'}</td>
                          <td>{r.job_title || '—'}</td>
                          <td>{r.country || '—'}</td>
                          <td style={{ maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '12px', color: '#6b7280' }}
                              title={r.form_name}>{r.form_name || '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                );
              })()}
            </div>

            {/* Footer */}
            <div className="modal-footer" style={{ borderTop: '1px solid #e5e7eb', padding: '16px 24px' }}>
              <span style={{ fontSize: '13px', color: '#6b7280', marginRight: 'auto' }}>
                {inviteRegistrations.length} total registration{inviteRegistrations.length !== 1 ? 's' : ''}
              </span>
              <button className="modal-btn modal-btn-cancel" onClick={handleCloseInviteModal}>
                Cancel
              </button>
              <button
                className="modal-btn modal-btn-confirm"
                onClick={handleSendInvites}
                disabled={selectedInvitees.size === 0}
              >
                📨 Send Invites ({selectedInvitees.size})
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const renderEventCategoriesSection = () => (
    <div className="section-content">
      <div className="section-header">
        <h2>Event Categories Management</h2>
        <div className="section-actions">
          <button className="action-btn action-btn-primary" onClick={handleOpenCategoryModal}>
            ➕ Add New Category
          </button>
          <button className="action-btn action-btn-secondary" onClick={fetchEventCategories}>
            🔄 Refresh
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <p>Loading event categories...</p>
        </div>
      ) : eventCategories.length === 0 ? (
        <div className="placeholder-content">
          <div className="placeholder-icon">🏷️</div>
          <h3>No Event Categories Found</h3>
          <p>Start by creating your first event category.</p>
          <button 
            className="action-btn action-btn-primary" 
            style={{ marginTop: '20px' }}
            onClick={handleOpenCategoryModal}
          >
            ➕ Create First Category
          </button>
        </div>
      ) : (
        <div className="table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Slug</th>
                <th>Description</th>
                <th style={{ textAlign: 'center' }}>Color</th>
                <th>Icon</th>
                <th style={{ textAlign: 'center' }}>Status</th>
                <th>Created</th>
                <th style={{ textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {eventCategories.map((category) => (
                <tr key={category.id}>
                  <td>{category.id}</td>
                  <td>
                    <strong>{category.name}</strong>
                  </td>
                  <td>
                    <span className="badge badge-info">{category.slug}</span>
                  </td>
                  <td>
                    <div style={{ maxWidth: '300px', fontSize: '13px', color: '#666' }}>
                      {category.description || '-'}
                    </div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {category.color ? (
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                        <div style={{
                          width: '32px',
                          height: '32px',
                          backgroundColor: category.color,
                          borderRadius: '6px',
                          border: '2px solid #e0e0e0'
                        }}></div>
                        <span style={{ fontSize: '12px', color: '#666' }}>{category.color}</span>
                      </div>
                    ) : (
                      <span style={{ color: '#999' }}>-</span>
                    )}
                  </td>
                  <td>
                    {category.icon ? (
                      <span style={{ fontSize: '20px' }}>{category.icon}</span>
                    ) : (
                      <span style={{ color: '#999' }}>-</span>
                    )}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className={`badge ${category.is_active ? 'badge-success' : 'badge-secondary'}`}>
                      {category.is_active ? '✓ Active' : '✗ Inactive'}
                    </span>
                  </td>
                  <td>
                    {new Date(category.created_at).toLocaleDateString('en-US', { 
                      year: 'numeric', 
                      month: 'short', 
                      day: 'numeric' 
                    })}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <div className="action-buttons">
                      <button
                        className="action-btn action-btn-email"
                        onClick={() => handleEditCategory(category)}
                        title="Edit Category"
                        disabled={actionLoading === `editing-category-${category.id}`}
                      >
                        ✏️
                      </button>
                      <button
                        className="action-btn action-btn-delete"
                        onClick={() => handleDeleteCategory(category.id, category.name)}
                        title="Delete Category"
                        disabled={actionLoading === `deleting-category-${category.id}`}
                      >
                        {actionLoading === `deleting-category-${category.id}` ? '⏳' : '🗑️'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Category Modal */}
      {showCategoryModal && (
        <div className="modal-overlay" onClick={handleCloseCategoryModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
            <div className="modal-header">
              <h2>{isEditingCategory ? 'Edit Event Category' : 'Create New Event Category'}</h2>
              <button className="modal-close" onClick={handleCloseCategoryModal}>×</button>
            </div>
            <div className="modal-body">
              <div className="form-section">
                <div className="form-group">
                  <label htmlFor="category_name">Category Name *</label>
                  <input
                    type="text"
                    id="category_name"
                    value={categoryFormData.name}
                    onChange={(e) => handleCategoryFormChange('name', e.target.value)}
                    placeholder="e.g., Technology, Business, Health"
                    required
                    autoFocus
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="category_slug">Slug *</label>
                  <input
                    type="text"
                    id="category_slug"
                    value={categoryFormData.slug}
                    onChange={(e) => handleCategoryFormChange('slug', e.target.value)}
                    placeholder="e.g., technology, business, health"
                    required
                  />
                  <small style={{ display: 'block', marginTop: '5px', color: '#666', fontSize: '12px' }}>
                    URL-friendly version (lowercase, hyphens only)
                  </small>
                </div>

                <div className="form-group">
                  <label htmlFor="category_description">Description</label>
                  <textarea
                    id="category_description"
                    value={categoryFormData.description}
                    onChange={(e) => handleCategoryFormChange('description', e.target.value)}
                    placeholder="Brief description of this category"
                    rows="3"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="category_color">Color</label>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <input
                        type="color"
                        id="category_color"
                        value={categoryFormData.color}
                        onChange={(e) => handleCategoryFormChange('color', e.target.value)}
                        style={{ width: '60px', height: '40px', border: '2px solid #ddd', borderRadius: '6px' }}
                      />
                      <input
                        type="text"
                        value={categoryFormData.color}
                        onChange={(e) => handleCategoryFormChange('color', e.target.value)}
                        placeholder="#3B82F6"
                        style={{ flex: 1 }}
                      />
                    </div>
                    <small style={{ display: 'block', marginTop: '5px', color: '#666', fontSize: '12px' }}>
                      Used for UI display
                    </small>
                  </div>

                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="category_icon">Icon (Emoji)</label>
                    <input
                      type="text"
                      id="category_icon"
                      value={categoryFormData.icon}
                      onChange={(e) => handleCategoryFormChange('icon', e.target.value)}
                      placeholder="e.g., 💻 🏢 ❤️"
                    />
                    <small style={{ display: 'block', marginTop: '5px', color: '#666', fontSize: '12px' }}>
                      Enter an emoji or icon
                    </small>
                  </div>
                </div>

                <div className="form-group">
                  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={categoryFormData.is_active}
                      onChange={(e) => handleCategoryFormChange('is_active', e.target.checked)}
                    />
                    <span>Active (visible to users)</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                className="modal-btn modal-btn-cancel" 
                onClick={handleCloseCategoryModal}
                disabled={actionLoading === 'saving-category'}
              >
                Cancel
              </button>
              <button 
                className="modal-btn modal-btn-confirm" 
                onClick={handleCategorySave}
                disabled={actionLoading === 'saving-category'}
              >
                {actionLoading === 'saving-category' ? '⏳ Saving...' : (isEditingCategory ? 'Update Category' : 'Create Category')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );


  const renderLeadsSection = () => (
    <>
      <div className="section-header" style={{ marginBottom: '20px' }}>
        <h2>Leads Management</h2>
        <div className="section-actions">
          <button className="action-btn action-btn-primary" onClick={handleOpenNewLeadModal}>
            ➕ New Lead
          </button>
          <button className="action-btn action-btn-secondary" onClick={fetchLeads}>
            🔄 Refresh
          </button>
        </div>
      </div>
        <div className="stats">
          <div 
            className={`stat-card ${interestedInFilter === 'All' && !showOnlyDuplicates ? 'stat-card-active' : ''}`}
            onClick={() => { setInterestedInFilter('All'); setShowOnlyDuplicates(false); setSeriesFilter('All'); setSourceFilter('All'); setSearchQuery(''); setCurrentPage(1); }}
            style={{ cursor: 'pointer' }}
            title="Click to view all leads"
          >
            <span className="stat-label">Total Leads</span>
            <span className="stat-value">{leads.length}</span>
          </div>
          <div 
            className="stat-card stat-card-warning" 
            onClick={handleDuplicateClick}
            style={{ cursor: 'pointer' }}
            title="Click to view duplicate leads"
          >
            <span className="stat-label">Duplicate Leads {showOnlyDuplicates && '(Active)'}</span>
            <span className="stat-value">{duplicateCount}</span>
          </div>
          {Object.entries(categoryCounts).map(([category, count]) => (
            <div 
              key={category} 
              className={`stat-card ${interestedInFilter === category && !showOnlyDuplicates ? 'stat-card-active' : ''}`}
              onClick={() => handleCategoryClick(category)}
              style={{ cursor: 'pointer' }}
              title={`Click to filter ${category.replace(/_/g, ' ')}`}
            >
              <span className="stat-label">{category.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</span>
              <span className="stat-value">{count}</span>
            </div>
          ))}
      </div>

      {/* Filters Section */}
        <div style={{ 
          marginTop: '24px', 
          padding: '20px', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '12px',
          border: '1px solid #e0e0e0'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {/* Search Box */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <label htmlFor="searchQuery" style={{ fontWeight: 600, fontSize: '14px', minWidth: '80px', color: '#333' }}>
                🔍 Search:
              </label>
              <input
                id="searchQuery"
                type="text"
                value={searchQuery}
                onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                placeholder="Search by name, email, or mobile..."
                style={{
                  padding: '10px 14px',
                  borderRadius: '8px',
                  border: '2px solid #ddd',
                  fontSize: '14px',
                  flex: 1,
                  transition: 'border-color 0.2s',
                  outline: 'none'
                }}
                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                onBlur={(e) => e.target.style.borderColor = '#ddd'}
              />
              {searchQuery && (
                <button
                  onClick={() => { setSearchQuery(''); setCurrentPage(1); }}
                  style={{
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: 'none',
                    backgroundColor: '#dc3545',
                    color: '#fff',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 600,
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
                >
                  ✕ Clear
                </button>
              )}
            </div>

          {/* Filter Row */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '16px', 
            flexWrap: 'wrap',
            paddingTop: '8px',
            borderTop: '1px solid #e0e0e0'
          }}>
            {/* Series Filter */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label htmlFor="seriesFilter" style={{ fontWeight: 600, fontSize: '14px', color: '#555' }}>
                📅 Age:
              </label>
              <select
                id="seriesFilter"
                value={seriesFilter}
                onChange={(e) => { setSeriesFilter(e.target.value); setCurrentPage(1); }}
                style={{
                  padding: '10px 14px',
                  borderRadius: '8px',
                  border: '2px solid #ddd',
                  fontSize: '14px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  backgroundColor: '#fff',
                  minWidth: '140px',
                  transition: 'border-color 0.2s',
                  outline: 'none'
                }}
                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                onBlur={(e) => e.target.style.borderColor = '#ddd'}
              >
                <option value="All">All Ages</option>
                <option value="1">1 Day Old</option>
                <option value="2">2 Days Old</option>
                <option value="3">3 Days Old</option>
                <option value="4">4 Days Old</option>
                <option value="5">5 Days Old</option>
                <option value="6">6 Days Old</option>
                <option value="7">7 Days Old</option>
                <option value="8">8 Days Old</option>
                <option value="9">9 Days Old</option>
                <option value="10">10 Days Old</option>
              </select>
            </div>

            {/* Source Filter */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label htmlFor="sourceFilter" style={{ fontWeight: 600, fontSize: '14px', color: '#555' }}>
                📍 Source:
              </label>
              <select
                id="sourceFilter"
                value={sourceFilter}
                onChange={(e) => { setSourceFilter(e.target.value); setCurrentPage(1); }}
                style={{
                  padding: '10px 14px',
                  borderRadius: '8px',
                  border: '2px solid #ddd',
                  fontSize: '14px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  backgroundColor: '#fff',
                  minWidth: '200px',
                  transition: 'border-color 0.2s',
                  outline: 'none'
                }}
                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                onBlur={(e) => e.target.style.borderColor = '#ddd'}
              >
                {sourceOptions.map(source => (
                  <option key={source} value={source}>
                    {source === 'All' ? 'All Sources' : source.replace(/_/g, ' ')}
                  </option>
                ))}
              </select>
            </div>

            {/* Interested In Filter */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label htmlFor="interestedInFilter" style={{ fontWeight: 600, fontSize: '14px', color: '#555' }}>
                🎯 Program:
              </label>
              <select
                id="interestedInFilter"
                value={interestedInFilter}
                onChange={(e) => { setInterestedInFilter(e.target.value); setCurrentPage(1); }}
                style={{
                  padding: '10px 14px',
                  borderRadius: '8px',
                  border: '2px solid #ddd',
                  fontSize: '14px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  backgroundColor: '#fff',
                  minWidth: '220px',
                  transition: 'border-color 0.2s',
                  outline: 'none'
                }}
                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                onBlur={(e) => e.target.style.borderColor = '#ddd'}
              >
                {interestedInOptions.map(option => (
                  <option key={option} value={option}>
                    {option === 'All' ? 'All Programs' : option.replace(/_/g, ' ')}
                  </option>
                ))}
              </select>
            </div>

            {/* Clear All Filters Button */}
            {(seriesFilter !== 'All' || sourceFilter !== 'All' || interestedInFilter !== 'All' || searchQuery !== '') && (
              <button
                onClick={() => {
                  setSeriesFilter('All');
                  setSourceFilter('All');
                  setInterestedInFilter('All');
                  setSearchQuery('');
                  setCurrentPage(1);
                }}
                style={{
                  padding: '10px 20px',
                  borderRadius: '8px',
                  border: 'none',
                  backgroundColor: '#6c757d',
                  color: '#fff',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 600,
                  marginLeft: 'auto',
                  transition: 'background-color 0.2s',
                  whiteSpace: 'nowrap'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#5a6268'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#6c757d'}
              >
                🗑️ Clear All
              </button>
            )}
          </div>

          {/* Active Filters Display */}
          {(seriesFilter !== 'All' || sourceFilter !== 'All' || interestedInFilter !== 'All' || searchQuery !== '') && (
            <div style={{ 
              fontSize: '13px', 
              color: '#666', 
              backgroundColor: '#fff',
              padding: '12px 16px',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '8px'
            }}>
              <span style={{ fontWeight: 600, color: '#333' }}>Active Filters:</span>
              {seriesFilter !== 'All' && (
                <span style={{ 
                  backgroundColor: '#007bff', 
                  color: '#fff', 
                  padding: '4px 10px', 
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: 500
                }}>
                  Age: {seriesFilter} day(s)
                </span>
              )}
              {sourceFilter !== 'All' && (
                <span style={{ 
                  backgroundColor: '#28a745', 
                  color: '#fff', 
                  padding: '4px 10px', 
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: 500
                }}>
                  Source: {sourceFilter.replace(/_/g, ' ')}
                </span>
              )}
              {interestedInFilter !== 'All' && (
                <span style={{ 
                  backgroundColor: '#17a2b8', 
                  color: '#fff', 
                  padding: '4px 10px', 
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: 500
                }}>
                  Program: {interestedInFilter.replace(/_/g, ' ')}
                </span>
              )}
              {searchQuery !== '' && (
                <span style={{ 
                  backgroundColor: '#ffc107', 
                  color: '#000', 
                  padding: '4px 10px', 
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: 500
                }}>
                  Search: "{searchQuery}"
                </span>
              )}
              <span style={{ 
                marginLeft: 'auto',
                fontWeight: 600,
                color: '#007bff'
              }}>
                {filteredLeads.length} result{filteredLeads.length !== 1 ? 's' : ''}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="table-container">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Consent</th>
              <th>Source</th>
              <th>Interested In</th>
              <th>Status</th>
              <th>Age (Days)</th>
              <th>Created At</th>
              <th>Profile PDF</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentLeads.map((lead) => {
              const isDuplicate = duplicateLeadIds.has(lead.id);
              const profilePdfUrl = getLeadProfilePdfUrl(lead);
              return (
                <tr key={lead.id} className={isDuplicate ? 'duplicate-row' : ''}>
                  <td>{lead.id}</td>
                  <td>{lead.name}</td>
                  <td>{lead.email}</td>
                  <td>{lead.mobile || 'N/A'}</td>
                  <td>
                    <span className={`badge ${lead.consent ? 'badge-success' : 'badge-danger'}`}>
                      {lead.consent ? 'Yes' : 'No'}
                    </span>
                  </td>
                  <td>
                    <span className="badge badge-info">{lead.source || 'N/A'}</span>
                  </td>
                  <td>{lead.interestedIn ? lead.interestedIn.replace(/_/g, ' ') : 'N/A'}</td>
                  <td>
                    <span className="badge badge-warning">{lead.status || 'new'}</span>
                  </td>
                  <td>
                    <span className="badge badge-info">{lead.Age} day{lead.Age !== 1 ? 's' : ''}</span>
                  </td>
                  <td>{formatDate(lead.createdAt)}</td>
                  <td>
                    {profilePdfUrl ? (
                      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                        <a
                          className="action-btn action-btn-secondary"
                          href={profilePdfUrl}
                          target="_blank"
                          rel="noreferrer"
                          style={{ padding: '4px 8px', fontSize: '12px' }}
                          title="Open profile PDF"
                        >
                          View
                        </a>
                        <a
                          className="action-btn action-btn-secondary"
                          href={profilePdfUrl}
                          target="_blank"
                          rel="noreferrer"
                          download
                          style={{ padding: '4px 8px', fontSize: '12px' }}
                          title="Download profile PDF"
                        >
                          Download
                        </a>
                      </div>
                    ) : (
                      <span style={{ color: '#6b7280', fontSize: '12px' }}>N/A</span>
                    )}
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn action-btn-feedback"
                        onClick={() => handleRequestFeedback(lead)}
                        disabled={actionLoading === lead.id}
                        title="Request Feedback"
                        style={{
                          backgroundColor: copiedLeadId === lead.id ? '#28a745' : '#17a2b8',
                          color: '#fff'
                        }}
                      >
                        {copiedLeadId === lead.id ? '✓' : '💬'}
                      </button>
                      <button
                        className="action-btn action-btn-secondary"
                        onClick={() => handleOpenInsights(lead)}
                        disabled={actionLoading === lead.id || !profilePdfUrl}
                        title="Marketing Insights"
                      >
                        📈
                      </button>
                      <button
                        className="action-btn action-btn-primary"
                        onClick={() => handleConvertLeadToUser(lead)}
                        disabled={actionLoading === lead.id}
                        title="Convert to User"
                        style={{
                          backgroundColor: '#28a745',
                          color: '#fff'
                        }}
                      >
                        👤
                      </button>
                      <button
                        className="action-btn action-btn-status"
                        onClick={() => handleChangeStatus(lead)}
                        disabled={actionLoading === lead.id}
                        title="Change Status"
                      >
                        🔄
                      </button>
                      <button
                        className="action-btn action-btn-delete"
                        onClick={() => handleDelete(lead.id, lead.name)}
                        disabled={actionLoading === lead.id}
                        title="Delete Lead"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-button"
          >
            Previous
          </button>
          
          <div className="pagination-numbers">
            {[...Array(totalPages)].map((_, index) => {
              const pageNumber = index + 1;
              if (
                pageNumber === 1 ||
                pageNumber === totalPages ||
                (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
              ) {
                return (
                  <button
                    key={pageNumber}
                    onClick={() => handlePageChange(pageNumber)}
                    className={`pagination-number ${currentPage === pageNumber ? 'active' : ''}`}
                  >
                    {pageNumber}
                  </button>
                );
              } else if (
                pageNumber === currentPage - 3 ||
                pageNumber === currentPage + 3
              ) {
                return <span key={pageNumber} className="pagination-ellipsis">...</span>;
              }
              return null;
            })}
          </div>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-button"
          >
            Next
          </button>
        </div>
      )}

      {showEmailModal && (
        <div className="modal-overlay" onClick={handleCloseEmailModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Send Email to Lead</h2>
              <button className="modal-close" onClick={handleCloseEmailModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <p className="modal-lead-info">
                <strong>Lead:</strong> {selectedLead?.name} ({selectedLead?.email})
              </p>
              <div className="form-group">
                <label htmlFor="emailLevelSelect">Select Email Type:</label>
                <select
                  id="emailLevelSelect"
                  value={emailLevel}
                  onChange={(e) => setEmailLevel(e.target.value)}
                  className="status-select"
                  autoFocus
                >
                  {(EMAIL_CONFIG[selectedLead?.interestedIn] || []).map((emailOption) => (
                    <option key={emailOption.level} value={emailOption.template}>
                      Level {emailOption.level}: {emailOption.subject}
                    </option>
                  ))}
                  {(!EMAIL_CONFIG[selectedLead?.interestedIn] || EMAIL_CONFIG[selectedLead?.interestedIn].length === 0) && (
                    <option value="copilot_welcome">No email templates available for this category</option>
                  )}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-btn modal-btn-cancel" onClick={handleCloseEmailModal}>
                Cancel
              </button>
              <button className="modal-btn modal-btn-confirm" onClick={handleEmailSubmit}>
                Send Email
              </button>
            </div>
          </div>
        </div>
      )}

      {showInsightsModal && insightsLead && (
        <div className="modal-overlay insights-drawer-overlay" onClick={handleCloseInsightsModal}>
          <div className="modal-content insights-drawer-content" onClick={(e) => e.stopPropagation()} style={{ background: '#14202B', border: '1px solid rgba(255,255,255,0.1)' }}>
            <div className="modal-header" style={{ background: '#1A2A38', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
              <h2>Lead Marketing Insights</h2>
              <button className="modal-close" onClick={handleCloseInsightsModal}>
                ×
              </button>
            </div>
            <div className="modal-body" style={{ color: '#E8EEF3' }}>
              <div style={{ marginBottom: '14px', padding: '12px', borderRadius: '8px', backgroundColor: '#1A2A38', border: '1px solid rgba(255,255,255,0.1)' }}>
                <p className="modal-lead-info" style={{ margin: '0 0 8px', background: '#223445', color: '#E8EEF3', border: '1px solid rgba(255,255,255,0.08)' }}>
                  <strong>Lead:</strong> {insightsLead.name} ({insightsLead.email})
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '8px', fontSize: '13px', color: '#C8D6E2' }}>
                  <div><strong>Lead Interests:</strong> {insightsLead.interestedIn ? insightsLead.interestedIn.replace(/_/g, ' ') : 'General'}</div>
                  <div><strong>Source:</strong> {insightsLead.source || 'N/A'}</div>
                  <div><strong>Status:</strong> {insightsLead.status || 'New'}</div>
                  <div><strong>Age:</strong> {insightsLead.Age ?? 0} day{(insightsLead.Age ?? 0) !== 1 ? 's' : ''}</div>
                </div>
              </div>

              <div style={{ border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '12px', background: '#1A2A38', marginBottom: '12px' }}>
                <div style={{ fontSize: '13px', fontWeight: 700, marginBottom: '6px', color: '#E8EEF3' }}>Summary</div>
                <div style={{ fontSize: '13px', lineHeight: 1.5, whiteSpace: 'pre-wrap', color: '#C8D6E2' }}>{formatInsightsValue(insightsPayload?.Summary)}</div>
              </div>

              <div style={{ border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '12px', background: '#1A2A38', marginBottom: '12px' }}>
                <div style={{ fontSize: '13px', fontWeight: 700, marginBottom: '6px', color: '#E8EEF3' }}>Channel Insights</div>
                {renderChannelInsights(insightsPayload?.ChannelInsights)}
              </div>

              <div style={{ marginBottom: '10px', fontSize: '14px', fontWeight: 600, color: '#E8EEF3' }}>Editable Marketing Emails</div>
              <div style={{ display: 'grid', gap: '12px' }}>
                {editableInsightsEmails.map((item, index) => {
                  const stageMeta = getFunnelStageMeta(index);
                  return (
                  <div
                    key={`insight-level-${item.Level}`}
                    style={{
                      border: `1px solid ${stageMeta.border}`,
                      borderRadius: '8px',
                      padding: '10px 12px',
                      backgroundColor: stageMeta.bg
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}>
                      <div style={{ fontSize: '12px', color: stageMeta.accent, fontWeight: 700 }}>Level {item.Level}</div>
                      <span
                        style={{
                          fontSize: '11px',
                          color: '#E8EEF3',
                          backgroundColor: '#14202B',
                          border: `1px solid ${stageMeta.border}`,
                          borderRadius: '999px',
                          padding: '2px 8px',
                          fontWeight: 600
                        }}
                      >
                        {stageMeta.label}
                      </span>
                    </div>

                    <div style={{ marginBottom: '8px' }}>
                      <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '4px', color: '#E8EEF3' }}>Subject</label>
                      <input
                        type="text"
                        value={item.Subject || ''}
                        onChange={(e) => handleInsightsEmailFieldChange(item.Level, 'Subject', e.target.value)}
                        style={{ width: '100%', padding: '8px 10px', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '6px', fontSize: '13px', background: '#14202B', color: '#E8EEF3' }}
                      />
                    </div>

                    <div style={{ marginBottom: '8px' }}>
                      <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '4px', color: '#E8EEF3' }}>Body</label>
                      <textarea
                        value={item.Body || ''}
                        onChange={(e) => handleInsightsEmailFieldChange(item.Level, 'Body', e.target.value)}
                        rows={4}
                        style={{ width: '100%', padding: '8px 10px', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '6px', fontSize: '13px', resize: 'vertical', background: '#14202B', color: '#E8EEF3' }}
                      />
                    </div>

                    <div style={{ marginBottom: '8px' }}>
                      <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '4px', color: '#E8EEF3' }}>CTA</label>
                      <input
                        type="text"
                        value={item.CTA || ''}
                        onChange={(e) => handleInsightsEmailFieldChange(item.Level, 'CTA', e.target.value)}
                        style={{ width: '100%', padding: '8px 10px', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '6px', fontSize: '13px', background: '#14202B', color: '#E8EEF3' }}
                      />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <button
                        type="button"
                        className="action-btn action-btn-primary"
                        disabled={insightEmailSendingLevel === item.Level}
                        onClick={() => handleSendInsightsEmail(item)}
                      >
                        {insightEmailSendingLevel === item.Level ? 'Sending...' : `Send Level ${item.Level} Email`}
                      </button>
                    </div>
                  </div>
                )})}
              </div>
            </div>
            <div className="modal-footer" style={{ background: '#1A2A38', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
              <button className="modal-btn modal-btn-cancel" onClick={handleCloseInsightsModal}>
                Close
              </button>
              <button
                className="modal-btn modal-btn-confirm"
                onClick={() => {
                  setSelectedLead(insightsLead);
                  const emailOptions = EMAIL_CONFIG[insightsLead.interestedIn] || [];
                  const defaultLevel = emailOptions.length > 0 ? emailOptions[0].template : 'copilot_welcome';
                  setEmailLevel(defaultLevel);
                  setShowEmailModal(true);
                  handleCloseInsightsModal();
                }}
              >
                Open Existing Template Flow
              </button>
            </div>
          </div>
        </div>
      )}

      {showNewLeadModal && (
        <div className="modal-overlay" onClick={handleCloseNewLeadModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '640px' }}>
            <div className="modal-header">
              <h2>Create New Lead</h2>
              <button className="modal-close" onClick={handleCloseNewLeadModal}>
                ×
              </button>
            </div>
            <form className="modal-body" onSubmit={handleCreateNewLead}>
              <div className="form-group">
                <label htmlFor="newLeadName">Name *</label>
                <input
                  id="newLeadName"
                  type="text"
                  value={newLeadFormData.name}
                  onChange={(e) => handleNewLeadFieldChange('name', e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label htmlFor="newLeadEmail">Email *</label>
                <input
                  id="newLeadEmail"
                  type="email"
                  value={newLeadFormData.email}
                  onChange={(e) => handleNewLeadFieldChange('email', e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="newLeadMobile">Mobile (Optional)</label>
                <input
                  id="newLeadMobile"
                  type="text"
                  value={newLeadFormData.mobile}
                  onChange={(e) => handleNewLeadFieldChange('mobile', e.target.value)}
                  placeholder="e.g. +919876543210"
                />
              </div>

              <div className="form-group">
                <label htmlFor="newLeadInterestedIn">Interested In</label>
                <select
                  id="newLeadInterestedIn"
                  value={newLeadFormData.interestedIn}
                  onChange={(e) => handleNewLeadFieldChange('interestedIn', e.target.value)}
                >
                  <optgroup label="Featured Programs">
                    {Object.keys(EMAIL_CONFIG).slice(0, 3).map((key) => (
                      <option key={key} value={key}>
                        {key.replace(/_/g, ' ')}
                      </option>
                    ))}
                  </optgroup>
                  <optgroup label="Agentic Programs">
                    <option value="agentic_qa">Agentic QA</option>
                    <option value="agentic_development">Agentic Development</option>
                    <option value="agentic_delivery">Agentic Delivery</option>
                    <option value="agentic_devops">Agentic DevOps</option>
                    <option value="agentic_infra">Agentic Infra</option>
                    <option value="agentic_observability">Agentic Observability</option>
                  </optgroup>
                  <optgroup label="Upcoming Events">
                    {newLeadEventsLoading && (
                      <option value="" disabled>Loading upcoming events...</option>
                    )}
                    {!newLeadEventsLoading && newLeadUpcomingEvents.length === 0 && (
                      <option value="" disabled>No upcoming events available</option>
                    )}
                    {!newLeadEventsLoading && newLeadUpcomingEvents.map((eventItem) => {
                      const eventDateLabel = formatEventDateForOption(eventItem);
                      const optionValue = `event_${eventItem.id}`;
                      return (
                        <option key={optionValue} value={optionValue}>
                          {eventItem.title || `Event ${eventItem.id}`}{eventDateLabel ? ` (${eventDateLabel})` : ''}
                        </option>
                      );
                    })}
                  </optgroup>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="newLeadStatus">Status</label>
                <input id="newLeadStatus" type="text" value="New" disabled />
              </div>

              <div className="form-group">
                <label htmlFor="newLeadProfilePdf">Profile Attachment (PDF)</label>
                <input id="newLeadProfilePdf" type="file" accept="application/pdf,.pdf" onChange={handleNewLeadPdfChange} />
                {newLeadProfilePdf && (
                  <small style={{ display: 'block', marginTop: '6px', color: '#16a34a' }}>
                    Selected: {newLeadProfilePdf.name}
                  </small>
                )}
              </div>

              <div className="form-group">
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={newLeadFormData.consent}
                    onChange={(e) => handleNewLeadFieldChange('consent', e.target.checked)}
                  />
                  <span>Content Provided</span>
                </label>
              </div>

              {newLeadError && (
                <div style={{ color: '#dc2626', marginBottom: '8px', fontSize: '14px' }}>
                  {newLeadError}
                </div>
              )}

              <div className="modal-footer" style={{ padding: 0, marginTop: '10px' }}>
                <button className="modal-btn modal-btn-cancel" type="button" onClick={handleCloseNewLeadModal} disabled={newLeadSubmitting}>
                  Cancel
                </button>
                <button className="modal-btn modal-btn-confirm" type="submit" disabled={newLeadSubmitting}>
                  {newLeadSubmitting ? 'Saving...' : 'Create Lead'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showStatusModal && (
        <div className="modal-overlay" onClick={handleCloseStatusModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Change Lead Status</h2>
              <button className="modal-close" onClick={handleCloseStatusModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <p className="modal-lead-info">
                <strong>Lead:</strong> {selectedLead?.name} ({selectedLead?.email})
              </p>
              <div className="form-group">
                <label htmlFor="statusSelect">Select New Status:</label>
                <select
                  id="statusSelect"
                  value={newStatus}
                  onChange={(e) => setNewStatus(e.target.value)}
                  className="status-select"
                  autoFocus
                >
                  <option value="New">New</option>
                  <option value="Contacted">Contacted</option>
                  <option value="In Conversation">In Conversation</option>
                  <option value="Nurturing">Nurturing</option>
                  <option value="Converted">Converted</option>
                  <option value="Closed Lost">Closed Lost</option>
                  <option value="Junk">Junk</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-btn modal-btn-cancel" onClick={handleCloseStatusModal}>
                Cancel
              </button>
              <button className="modal-btn modal-btn-confirm" onClick={handleStatusSubmit}>
                Update Status
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );

  return (
    <div className="admin-container ep-page">
      <div className="admin-sidebar" style={{
        background: 'linear-gradient(180deg, #111b25 0%, #162533 70%, #1a2a38 100%)',
        borderRight: '1px solid rgba(255,255,255,0.08)',
        boxShadow: '4px 0 24px rgba(0,0,0,0.35)',
      }}>
        <div className="sidebar-header" style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <span className="ep-live-badge" style={{ marginBottom: 0 }}>
            <span className="ep-pulse-dot" />
            LWT Admin
          </span>
        </div>
        <nav className="sidebar-nav">
          <button 
            className={`nav-item ${activeSection === 'dashboard' ? 'active' : ''}`}
            style={activeSection === 'dashboard' ? { background: 'rgba(222,44,30,0.18)', borderLeft: '3px solid rgba(222,44,30,0.7)', color: '#fff' } : {}}
            onClick={() => setActiveSection('dashboard')}
          >
            <span className="nav-icon">📊</span>
            <span className="nav-label">Dashboard</span>
          </button>
          <button 
            className={`nav-item ${activeSection === 'leads' ? 'active' : ''}`}
            onClick={() => setActiveSection('leads')}
          >
            <span className="nav-icon">📧</span>
            <span className="nav-label">Leads</span>
          </button>
          <button 
            className={`nav-item ${activeSection === 'courses' ? 'active' : ''}`}
            onClick={() => setActiveSection('courses')}
          >
            <span className="nav-icon">📚</span>
            <span className="nav-label">Courses</span>
          </button>
          <button 
            className={`nav-item ${activeSection === 'enrollments' ? 'active' : ''}`}
            onClick={() => setActiveSection('enrollments')}
          >
            <span className="nav-icon">👥</span>
            <span className="nav-label">Enrollments</span>
          </button>
          <button 
            className={`nav-item ${activeSection === 'users' ? 'active' : ''}`}
            onClick={() => setActiveSection('users')}
          >
            <span className="nav-icon">🧑</span>
            <span className="nav-label">Users</span>
          </button>
          <button 
            className={`nav-item ${activeSection === 'events' ? 'active' : ''}`}
            onClick={() => setActiveSection('events')}
          >
            <span className="nav-icon">📅</span>
            <span className="nav-label">Events</span>
          </button>
          <button
            className={`nav-item ${activeSection === 'jobs' ? 'active' : ''}`}
            onClick={() => setActiveSection('jobs')}
          >
            <span className="nav-icon">💼</span>
            <span className="nav-label">Jobs</span>
          </button>
          <button
            className={`nav-item ${activeSection === 'jobApplications' ? 'active' : ''}`}
            onClick={() => setActiveSection('jobApplications')}
          >
            <span className="nav-icon">📄</span>
            <span className="nav-label">Job Applications</span>
          </button>
          <button 
            className={`nav-item ${activeSection === 'eventCategories' ? 'active' : ''}`}
            onClick={() => setActiveSection('eventCategories')}
          >
            <span className="nav-icon">🏷️</span>
            <span className="nav-label">Event Categories</span>
          </button>
          <button
            className={`nav-item ${activeSection === 'eventRegistrations' ? 'active' : ''}`}
            onClick={() => setActiveSection('eventRegistrations')}
          >
            <span className="nav-icon">📨</span>
            <span className="nav-label">External Event Leads</span>
          </button>
          <button
            className={`nav-item ${activeSection === 'meetupGroup' ? 'active' : ''}`}
            onClick={() => setActiveSection('meetupGroup')}
          >
            <span className="nav-icon">M</span>
            <span className="nav-label">MeetupGroup</span>
          </button>
          <button className={`nav-item ${activeSection === 'meetupEvents' ? 'active' : ''}`} onClick={() => setActiveSection('meetupEvents')}>
            <span className="nav-icon">ME</span><span className="nav-label">Meetup Events</span>
          </button>
          <button className={`nav-item ${activeSection === 'meetupAttendees' ? 'active' : ''}`} onClick={() => setActiveSection('meetupAttendees')}>
            <span className="nav-icon">MA</span><span className="nav-label">Meetup events attendees</span>
          </button>
          <button className={`nav-item ${activeSection === 'ratings' ? 'active' : ''}`} onClick={() => setActiveSection('ratings')}>
            <span className="nav-icon">★</span><span className="nav-label">Ratings</span>
          </button>
          <button
            className={`nav-item ${activeSection === 'pastEventImages' ? 'active' : ''}`}
            onClick={() => setActiveSection('pastEventImages')}
          >
            <span className="nav-icon">🖼️</span>
            <span className="nav-label">Past Event Images</span>
          </button>
          <button
            className={`nav-item ${activeSection === 'quizzes' ? 'active' : ''}`}
            onClick={() => setActiveSection('quizzes')}
          >
            <span className="nav-icon">📝</span>
            <span className="nav-label">Quizzes</span>
          </button>
          <button
            className={`nav-item ${activeSection === 'feedbacks' ? 'active' : ''}`}
            onClick={() => setActiveSection('feedbacks')}
          >
            <span className="nav-icon">⭐</span>
            <span className="nav-label">Feedbacks</span>
          </button>
          <button
            className={`nav-item ${activeSection === 'surveys' ? 'active' : ''}`}
            onClick={() => { setActiveSection('surveys'); fetchSurveys(1, surveysStatusFilter); }}
          >
            <span className="nav-icon">📋</span>
            <span className="nav-label">Surveys</span>
          </button>
          <button
            className={`nav-item ${activeSection === 'eventNotifications' ? 'active' : ''}`}
            onClick={() => setActiveSection('eventNotifications')}
          >
            <span className="nav-icon">🔔</span>
            <span className="nav-label">Event Notifications</span>
          </button>
        </nav>
        <div className="sidebar-footer" style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <button
            onClick={handleLogout}
            className="ep-btn-ghost"
            style={{ width: '100%', justifyContent: 'center', gap: '8px', padding: '11px', borderRadius: '10px' }}
          >
            🚪 Logout
          </button>
        </div>
      </div>

      <div className="admin-main">
        <div className="admin-header" style={{
          background: '#1A2A38',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          padding: '16px 28px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}>
          <span className="ep-live-badge" style={{ flexShrink: 0 }}>
            <span className="ep-pulse-dot" />
            Admin Portal
          </span>
          <h1 style={{ margin: 0, fontSize: '20px', fontWeight: 800, color: '#E8EEF3', letterSpacing: '-0.01em' }}>
            {activeSection === 'dashboard' && 'Dashboard Overview'}
            {activeSection === 'leads' && 'Leads Management'}
            {activeSection === 'courses' && 'Courses Management'}
            {activeSection === 'enrollments' && 'Enrollments Management'}
            {activeSection === 'users' && 'Users Management'}
            {activeSection === 'events' && 'Events Management'}
            {activeSection === 'jobs' && 'Jobs Management'}
            {activeSection === 'jobApplications' && 'Job Applications'}
            {activeSection === 'eventCategories' && 'Event Categories'}
            {activeSection === 'eventRegistrations' && 'External Event Leads'}
            {activeSection === 'meetupGroup' && 'MeetupGroup Members'}
            {activeSection === 'meetupEvents' && 'Meetup Events'}
            {activeSection === 'meetupAttendees' && 'Meetup event attendees'}
            {activeSection === 'ratings' && 'Ratings Management'}
            {activeSection === 'pastEventImages' && 'Past Event Images'}
            {activeSection === 'quizzes' && 'Quizzes Management'}
            {activeSection === 'feedbacks' && 'Feedbacks Management'}
            {activeSection === 'surveys' && 'Surveys Management'}
            {activeSection === 'eventNotifications' && 'Event Notifications Management'}
          </h1>
        </div>

        <div className="admin-content">
          {activeSection === 'dashboard' && renderDashboard()}
          {activeSection === 'leads' && renderLeadsSection()}
          {activeSection === 'courses' && renderCoursesSection()}
          {activeSection === 'enrollments' && renderEnrollmentsSection()}
          {activeSection === 'users' && renderUsersSection()}
          {activeSection === 'events' && renderEventsSection()}
          {activeSection === 'eventCategories' && renderEventCategoriesSection()}
          {activeSection === 'jobs' && renderJobsSection()}
          {activeSection === 'jobApplications' && renderJobApplicationsSection()}
          {activeSection === 'eventRegistrations' && <EventRegistrations />}
          {activeSection === 'meetupGroup' && <MeetupGroup />}
          {activeSection === 'meetupEvents' && <MeetupEvents />}
          {activeSection === 'meetupAttendees' && <MeetupAttendees />}
          {activeSection === 'ratings' && <Ratings />}
          {activeSection === 'pastEventImages' && renderPastEventImagesSection()}
          {activeSection === 'quizzes' && renderQuizzesSection()}
          {activeSection === 'feedbacks' && renderFeedbacksSection()}
          {activeSection === 'surveys' && renderSurveysSection()}
          {activeSection === 'eventNotifications' && <EventNotifications />}
              
        </div>
      </div>

      {showCourseModal && (
        <div className="modal-overlay" onClick={handleCloseCourseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto' }}>
            <div className="modal-header">
              <h2>{isEditMode ? 'Edit Course' : 'Create New Course'}</h2>
              <button className="modal-close" onClick={handleCloseCourseModal}>×</button>
            </div>
            <div className="modal-body">
              {/* Basic Information */}
              <div className="form-section">
                <h3 className="form-section-title">📚 Basic Information</h3>
                <div className="form-row">
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="course_code">Course Code *</label>
                    <input
                      type="text"
                      id="course_code"
                      value={courseFormData.course_code}
                      onChange={(e) => handleCourseFormChange('course_code', e.target.value)}
                      placeholder="GH-300"
                      required
                    />
                  </div>
                  <div className="form-group" style={{ flex: 2 }}>
                    <label htmlFor="title">Course Title *</label>
                    <input
                      type="text"
                      id="title"
                      value={courseFormData.title}
                      onChange={(e) => handleCourseFormChange('title', e.target.value)}
                      placeholder="GitHub Copilot Expert Training"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="slug">URL Slug *</label>
                  <input
                    type="text"
                    id="slug"
                    value={courseFormData.slug}
                    onChange={(e) => handleCourseFormChange('slug', e.target.value)}
                    placeholder="github-copilot-expert"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="short_description">Short Description</label>
                  <input
                    type="text"
                    id="short_description"
                    value={courseFormData.short_description}
                    onChange={(e) => handleCourseFormChange('short_description', e.target.value)}
                    placeholder="Master GitHub Copilot for AI-powered development"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="description">Full Description</label>
                  <textarea
                    id="description"
                    value={courseFormData.description}
                    onChange={(e) => handleCourseFormChange('description', e.target.value)}
                    placeholder="Comprehensive training on GitHub Copilot..."
                    rows="4"
                  />
                </div>
              </div>

              {/* Media */}
              <div className="form-section">
                <h3 className="form-section-title">🎬 Media</h3>
                <div className="form-group">
                  <label htmlFor="thumbnail_url">Thumbnail URL</label>
                  <input
                    type="url"
                    id="thumbnail_url"
                    value={courseFormData.thumbnail_url}
                    onChange={(e) => handleCourseFormChange('thumbnail_url', e.target.value)}
                    placeholder="https://example.com/images/course-thumbnail.jpg"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="preview_video_url">Preview Video URL</label>
                  <input
                    type="url"
                    id="preview_video_url"
                    value={courseFormData.preview_video_url}
                    onChange={(e) => handleCourseFormChange('preview_video_url', e.target.value)}
                    placeholder="https://youtube.com/watch?v=xyz"
                  />
                </div>
              </div>

              {/* Course Details */}
              <div className="form-section">
                <h3 className="form-section-title">📋 Course Details</h3>
                <div className="form-row">
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="category">Category</label>
                    <input
                      type="text"
                      id="category"
                      value={courseFormData.category}
                      onChange={(e) => handleCourseFormChange('category', e.target.value)}
                      placeholder="AI Development"
                    />
                  </div>
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="level">Level *</label>
                    <select
                      id="level"
                      value={courseFormData.level}
                      onChange={(e) => handleCourseFormChange('level', e.target.value)}
                    >
                      <option value="beginner">Beginner</option>
                      <option value="intermediate">Intermediate</option>
                      <option value="advanced">Advanced</option>
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="language">Language</label>
                    <input
                      type="text"
                      id="language"
                      value={courseFormData.language}
                      onChange={(e) => handleCourseFormChange('language', e.target.value)}
                      placeholder="English"
                    />
                  </div>
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="duration_hours">Duration (hours)</label>
                    <input
                      type="number"
                      id="duration_hours"
                      value={courseFormData.duration_hours}
                      onChange={(e) => handleCourseFormChange('duration_hours', e.target.value)}
                      min="0"
                      placeholder="40"
                    />
                  </div>
                </div>
              </div>

              {/* Pricing & Enrollment */}
              <div className="form-section">
                <h3 className="form-section-title">💰 Pricing & Enrollment</h3>
                <div className="form-row">
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="price_usd">Price (USD $)</label>
                    <input
                      type="number"
                      id="price_usd"
                      value={courseFormData.price_usd}
                      onChange={(e) => handleCourseFormChange('price_usd', e.target.value)}
                      min="0"
                      step="0.01"
                      placeholder="299.99"
                    />
                  </div>
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="price_inr">Price (INR ₹)</label>
                    <input
                      type="number"
                      id="price_inr"
                      value={courseFormData.price_inr}
                      onChange={(e) => handleCourseFormChange('price_inr', e.target.value)}
                      min="0"
                      step="0.01"
                      placeholder="24999.00"
                    />
                  </div>
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="price_aud">Price (AUD A$)</label>
                    <input
                      type="number"
                      id="price_aud"
                      value={courseFormData.price_aud}
                      onChange={(e) => handleCourseFormChange('price_aud', e.target.value)}
                      min="0"
                      step="0.01"
                      placeholder="449.99"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="enrollment_limit">Enrollment Limit</label>
                    <input
                      type="number"
                      id="enrollment_limit"
                      value={courseFormData.enrollment_limit}
                      onChange={(e) => handleCourseFormChange('enrollment_limit', e.target.value)}
                      min="0"
                      placeholder="100 (0 = unlimited)"
                    />
                  </div>
                </div>
              </div>

              {/* Learning Details */}
              <div className="form-section">
                <h3 className="form-section-title">🎯 Learning Details</h3>
                <div className="form-group">
                  <label htmlFor="prerequisites">Prerequisites (one per line)</label>
                  <textarea
                    id="prerequisites"
                    value={courseFormData.prerequisites}
                    onChange={(e) => handleCourseFormChange('prerequisites', e.target.value)}
                    placeholder="Basic JavaScript\nGit fundamentals"
                    rows="3"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="learning_outcomes">Learning Outcomes (one per line)</label>
                  <textarea
                    id="learning_outcomes"
                    value={courseFormData.learning_outcomes}
                    onChange={(e) => handleCourseFormChange('learning_outcomes', e.target.value)}
                    placeholder="Master GitHub Copilot features\nBuild AI-powered applications"
                    rows="3"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="target_audience">Target Audience</label>
                  <input
                    type="text"
                    id="target_audience"
                    value={courseFormData.target_audience}
                    onChange={(e) => handleCourseFormChange('target_audience', e.target.value)}
                    placeholder="Developers with 2+ years of experience"
                  />
                </div>
              </div>

              {/* Status Flags */}
              <div className="form-section">
                <h3 className="form-section-title">⚙️ Status & Settings</h3>
                <div className="form-row" style={{ gap: '20px' }}>
                  <div className="form-group-checkbox">
                    <input
                      type="checkbox"
                      id="is_published"
                      checked={courseFormData.is_published}
                      onChange={(e) => handleCourseFormChange('is_published', e.target.checked)}
                    />
                    <label htmlFor="is_published">Published</label>
                  </div>
                  <div className="form-group-checkbox">
                    <input
                      type="checkbox"
                      id="is_featured"
                      checked={courseFormData.is_featured}
                      onChange={(e) => handleCourseFormChange('is_featured', e.target.checked)}
                    />
                    <label htmlFor="is_featured">Featured</label>
                  </div>
                  <div className="form-group-checkbox">
                    <input
                      type="checkbox"
                      id="certificate_available"
                      checked={courseFormData.certificate_available}
                      onChange={(e) => handleCourseFormChange('certificate_available', e.target.checked)}
                    />
                    <label htmlFor="certificate_available">Certificate Available</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-btn modal-btn-cancel" onClick={handleCloseCourseModal}>Cancel</button>
              <button 
                className="modal-btn modal-btn-confirm" 
                onClick={handleCreateCourse}
                disabled={actionLoading === 'course-create' || !courseFormData.course_code || !courseFormData.title || !courseFormData.slug}
              >
                {actionLoading === 'course-create' 
                  ? (isEditMode ? 'Updating...' : 'Creating...') 
                  : (isEditMode ? 'Update Course' : 'Create Course')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showModulesModal && (
        <>
          <div 
            className="modal-overlay" 
            onClick={handleCloseModulesModal}
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
          ></div>
          <div 
            className="slider-panel"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '60%',
              height: '100vh',
              backgroundColor: '#fff',
              boxShadow: '2px 0 10px rgba(0,0,0,0.3)',
              zIndex: 10001,
              display: 'flex',
              flexDirection: 'column',
              animation: 'slideInFromLeft 0.3s ease-out'
            }}
          >
            {/* Header */}
            <div style={{
              padding: '20px 24px',
              borderBottom: '1px solid #e0e0e0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: '#f8f9fa'
            }}>
              <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600 }}>📑 Manage Modules - {selectedCourse?.title}</h2>
              <button 
                onClick={handleCloseModulesModal}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '28px',
                  cursor: 'pointer',
                  color: '#666',
                  lineHeight: 1,
                  padding: 0
                }}
              >×</button>
            </div>

            {/* Scrollable Content */}
            <div style={{
              flex: 1,
              overflowY: 'auto',
              padding: '24px'
            }}>
              {/* File Upload Section - On Top */}
              <div style={{ 
                padding: '20px', 
                backgroundColor: '#e3f2fd', 
                borderRadius: '8px', 
                marginBottom: '24px',
                border: '1px solid #90caf9'
              }}>
                <h3 style={{ margin: '0 0 16px 0', color: '#1976d2', fontSize: '18px', fontWeight: 600 }}>📤 Upload New Modules</h3>
                
                <div style={{ marginBottom: '16px' }}>
                  <label htmlFor="xlsxUpload" style={{ display: 'block', marginBottom: '8px', fontWeight: 600, fontSize: '14px' }}>
                    Select Excel File (.xlsx, .xls)
                  </label>
                  <input
                    type="file"
                    id="xlsxUpload"
                    accept=".xlsx,.xls"
                    onChange={handleFileUpload}
                    style={{
                      padding: '12px',
                      border: '2px dashed #1976d2',
                      borderRadius: '8px',
                      width: '100%',
                      cursor: 'pointer',
                      backgroundColor: '#fff'
                    }}
                  />
                  {xlsxFile && (
                    <p style={{ marginTop: '8px', fontSize: '14px', color: '#28a745', fontWeight: 600 }}>
                      ✓ File selected: {xlsxFile.name}
                    </p>
                  )}
                </div>

                <details style={{ marginTop: '12px' }}>
                  <summary style={{ cursor: 'pointer', fontWeight: 600, fontSize: '14px', color: '#1976d2' }}>📋 Excel File Format Guide</summary>
                  <div style={{ marginTop: '12px', paddingLeft: '8px' }}>
                    <p style={{ margin: '0 0 8px 0', fontSize: '13px', color: '#555' }}>Your Excel file should contain the following columns:</p>
                    <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px', color: '#555', lineHeight: '1.6' }}>
                      <li><strong>Module Title</strong> - Name of the module (required)</li>
                      <li><strong>Module Order</strong> - Display order number</li>
                      <li><strong>Module Description</strong> - Module description text</li>
                      <li><strong>Lesson Title</strong> - Name of the lesson (required for lessons)</li>
                      <li><strong>Lesson Order</strong> - Display order within module</li>
                      <li><strong>Lesson Slug</strong> - URL-friendly lesson identifier</li>
                      <li><strong>Content Type</strong> - video, text, quiz, assignment, etc.</li>
                      <li><strong>Content</strong> - HTML content or description</li>
                      <li><strong>Video URL</strong> - Link to video (if content type is video)</li>
                      <li><strong>Duration (min)</strong> - Estimated duration in minutes</li>
                      <li><strong>Is Preview</strong> - true/false (can be viewed without enrollment)</li>
                    </ul>
                  </div>
                </details>

                {uploadedModules.length > 0 && (
                  <div style={{ marginTop: '16px' }}>
                    <h4 style={{ margin: '0 0 12px 0', color: '#1976d2', fontSize: '15px' }}>👀 Preview ({uploadedModules.length} module{uploadedModules.length !== 1 ? 's' : ''} to upload)</h4>
                    <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #90caf9', borderRadius: '6px', padding: '12px', backgroundColor: '#fff' }}>
                      {uploadedModules.map((module, moduleIndex) => (
                        <div key={moduleIndex} style={{ marginBottom: '16px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '6px', border: '1px solid #e0e0e0' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                            <span style={{ 
                              backgroundColor: '#667eea', 
                              color: '#fff', 
                              padding: '3px 10px', 
                              borderRadius: '4px', 
                              fontSize: '11px',
                              fontWeight: '600'
                            }}>
                              Module {module.display_order || moduleIndex + 1}
                            </span>
                            <strong style={{ fontSize: '14px' }}>{module.title}</strong>
                          </div>
                          {module.description && (
                            <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#666' }}>{module.description}</p>
                          )}
                          {module.lessons && module.lessons.length > 0 && (
                            <div style={{ paddingLeft: '12px' }}>
                              {module.lessons.map((lesson, lessonIndex) => (
                                <div key={lessonIndex} style={{ 
                                  marginBottom: '6px', 
                                  padding: '6px 10px', 
                                  backgroundColor: '#fff', 
                                  borderRadius: '4px',
                                  borderLeft: '3px solid #667eea',
                                  fontSize: '12px'
                                }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                    <span style={{ fontWeight: '600', color: '#333' }}>
                                      {lesson.display_order || lessonIndex + 1}. {lesson.title}
                                    </span>
                                    <span className="badge badge-info" style={{ fontSize: '11px' }}>{lesson.content_type}</span>
                                    {lesson.estimated_duration > 0 && (
                                      <span style={{ fontSize: '12px', color: '#666' }}>⏱️ {lesson.estimated_duration}min</span>
                                    )}
                                    {lesson.is_preview && (
                                      <span className="badge badge-success" style={{ fontSize: '11px' }}>Preview</span>
                                    )}
                                  </div>
                                  {lesson.video_url && (
                                    <div style={{ fontSize: '12px', color: '#0066cc', marginTop: '4px', marginBottom: '4px' }}>
                                      🎥 {lesson.video_url}
                                      {lesson.video_duration > 0 && (
                                        <span style={{ marginLeft: '8px', color: '#666' }}>({Math.floor(lesson.video_duration / 60)}:{String(lesson.video_duration % 60).padStart(2, '0')})</span>
                                      )}
                                    </div>
                                  )}
                                  {lesson.document_url && (
                                    <div style={{ fontSize: '12px', color: '#0066cc', marginTop: '4px', marginBottom: '4px' }}>📄 {lesson.document_url}</div>
                                  )}
                                  {lesson.content && (
                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '6px', lineHeight: '1.4' }}>
                                      {lesson.content.length > 150 ? `${lesson.content.substring(0, 150)}...` : lesson.content}
                                    </div>
                                  )}
                                  <div style={{ display: 'flex', gap: '12px', marginTop: '8px', fontSize: '11px', color: '#999', flexWrap: 'wrap' }}>
                                    <span>ID: {lesson.id}</span>
                                    <span>Slug: {lesson.slug || 'N/A'}</span>
                                    {lesson.created_at && (
                                      <span>Created: {new Date(lesson.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    <button 
                      onClick={handleUploadModules}
                      disabled={actionLoading === 'modules-upload'}
                      style={{
                        marginTop: '12px',
                        padding: '10px 20px',
                        backgroundColor: actionLoading === 'modules-upload' ? '#ccc' : '#1976d2',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: actionLoading === 'modules-upload' ? 'not-allowed' : 'pointer',
                        fontWeight: 600,
                        fontSize: '14px',
                        width: '100%'
                      }}
                    >
                      {actionLoading === 'modules-upload' ? 'Uploading...' : `✓ Upload ${uploadedModules.length} Module${uploadedModules.length !== 1 ? 's' : ''}`}
                    </button>
                  </div>
                )}
              </div>

              {/* Existing Modules Section */}
              <div style={{
                padding: '20px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #e0e0e0'
              }}>
                <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: '18px', fontWeight: 600 }}>📚 Current Modules</h3>
                
                {loadingModules ? (
                  <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                    <div style={{ fontSize: '40px', marginBottom: '16px' }}>⏳</div>
                    <p style={{ fontSize: '13px', color: '#666' }}>Loading modules...</p>
                  </div>
                ) : existingModules.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                    <div style={{ fontSize: '40px', marginBottom: '16px' }}>📭</div>
                    <p>No modules found for this course.</p>
                    <p style={{ fontSize: '13px', marginTop: '8px' }}>Upload an Excel file to add modules and lessons.</p>
                  </div>
                ) : (
                  <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                    {existingModules.map((module, moduleIndex) => {
                      const isExpanded = expandedModules.has(module.id);
                      return (
                        <div key={module.id || moduleIndex} style={{ 
                          marginBottom: '12px', 
                          backgroundColor: '#fff', 
                          borderRadius: '8px', 
                          border: '1px solid #e0e0e0',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                          overflow: 'hidden'
                        }}>
                          {/* Module Header - Clickable */}
                          <div 
                            onClick={() => toggleModuleExpand(module.id)}
                            style={{ 
                              padding: '14px 16px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px',
                              backgroundColor: isExpanded ? '#e8f5e9' : '#fff',
                              transition: 'background-color 0.2s',
                              borderBottom: isExpanded ? '1px solid #e0e0e0' : 'none'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = isExpanded ? '#e8f5e9' : '#f8f9fa'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = isExpanded ? '#e8f5e9' : '#fff'}
                          >
                            <span style={{ fontSize: '16px', color: '#666' }}>
                              {isExpanded ? '▼' : '▶'}
                            </span>
                            <span style={{ 
                              backgroundColor: module.is_published ? '#28a745' : '#ffc107', 
                              color: module.is_published ? '#fff' : '#000', 
                              padding: '4px 12px', 
                              borderRadius: '4px', 
                              fontSize: '12px',
                              fontWeight: '600'
                            }}>
                              Module {module.display_order || moduleIndex + 1}
                            </span>
                            <strong style={{ fontSize: '15px', color: '#333', flex: 1 }}>{module.title}</strong>
                            <span style={{ fontSize: '12px', color: '#999' }}>
                              ID: {module.id}
                            </span>
                          </div>
                          
                          {/* Module Content - Collapsible */}
                          {isExpanded && (
                            <div style={{ padding: '16px' }}>
                              {module.description && (
                                <div style={{ marginBottom: '12px' }}>
                                  <div style={{ fontSize: '12px', fontWeight: 600, color: '#666', marginBottom: '6px' }}>📝 Description:</div>
                                  <p style={{ margin: 0, fontSize: '14px', color: '#666', lineHeight: '1.5' }}>{module.description}</p>
                                </div>
                              )}
                              
                              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '13px', color: '#666' }}>
                                <div>
                                  <strong>Status:</strong> 
                                  <span className={`badge ${module.is_published ? 'badge-success' : 'badge-warning'}`} style={{ marginLeft: '6px', fontSize: '11px' }}>
                                    {module.is_published ? '✓ Published' : '⏳ Draft'}
                                  </span>
                                </div>
                                <div><strong>Created:</strong> {new Date(module.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</div>
                                <div><strong>Updated:</strong> {new Date(module.updated_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</div>
                              </div>
                              
                              {/* Lessons Section */}
                              <div style={{ marginTop: '16px' }}>
                                <div style={{ fontSize: '13px', fontWeight: 600, color: '#666', marginBottom: '10px' }}>
                                  📝 Lessons {moduleLessons[module.id] ? `(${moduleLessons[module.id].length})` : ''}
                                </div>
                                
                                {loadingLessons[module.id] ? (
                                  <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '6px', border: '1px solid #e0e0e0', textAlign: 'center' }}>
                                    <div style={{ fontSize: '24px', marginBottom: '8px' }}>⏳</div>
                                    <div style={{ fontSize: '13px', color: '#666' }}>Loading lessons...</div>
                                  </div>
                                ) : moduleLessons[module.id] && moduleLessons[module.id].length > 0 ? (
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    {moduleLessons[module.id].map((lesson, lessonIndex) => (
                                      <div key={lesson.id || lessonIndex} style={{ 
                                        padding: '12px 14px', 
                                        backgroundColor: '#fff', 
                                        borderRadius: '6px',
                                        border: '1px solid #e0e0e0',
                                        borderLeft: '3px solid #28a745'
                                      }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '6px' }}>
                                          <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                            {lesson.display_order || lessonIndex + 1}. {lesson.title}
                                          </span>
                                          <span className="badge badge-info" style={{ fontSize: '11px' }}>{lesson.content_type || 'text'}</span>
                                          {lesson.estimated_duration > 0 && (
                                            <span style={{ fontSize: '12px', color: '#666' }}>⏱️ {lesson.estimated_duration}min</span>
                                          )}
                                          {lesson.is_preview && (
                                            <span className="badge badge-success" style={{ fontSize: '11px' }}>Preview</span>
                                          )}
                                          {!lesson.is_published && (
                                            <span className="badge badge-warning" style={{ fontSize: '11px' }}>Draft</span>
                                          )}
                                          {lesson.points > 0 && (
                                            <span style={{ fontSize: '11px', color: '#666' }}>🏆 {lesson.points} pts</span>
                                          )}
                                        </div>
                                        {lesson.video_url && (
                                          <div style={{ fontSize: '12px', color: '#0066cc', marginTop: '4px', marginBottom: '4px' }}>
                                            🎥 {lesson.video_url}
                                            {lesson.video_duration > 0 && (
                                              <span style={{ marginLeft: '8px', color: '#666' }}>({Math.floor(lesson.video_duration / 60)}:{String(lesson.video_duration % 60).padStart(2, '0')})</span>
                                            )}
                                          </div>
                                        )}
                                        {lesson.document_url && (
                                          <div style={{ fontSize: '12px', color: '#0066cc', marginTop: '4px', marginBottom: '4px' }}>📄 {lesson.document_url}</div>
                                        )}
                                        {lesson.content && (
                                          <div style={{ fontSize: '12px', color: '#666', marginTop: '6px', lineHeight: '1.4' }}>
                                            {lesson.content.length > 150 ? `${lesson.content.substring(0, 150)}...` : lesson.content}
                                          </div>
                                        )}
                                        <div style={{ display: 'flex', gap: '12px', marginTop: '8px', fontSize: '11px', color: '#999', flexWrap: 'wrap' }}>
                                          <span>ID: {lesson.id}</span>
                                          <span>Slug: {lesson.slug || 'N/A'}</span>
                                          {lesson.created_at && (
                                            <span>Created: {new Date(lesson.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                ) : moduleLessons[module.id] ? (
                                  <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '6px', border: '1px dashed #ddd', textAlign: 'center' }}>
                                    <div style={{ fontSize: '24px', marginBottom: '8px' }}>📭</div>
                                    <div style={{ fontSize: '13px', color: '#666' }}>No lessons found in this module</div>
                                  </div>
                                ) : (
                                  <div style={{ padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '6px', border: '1px dashed #ddd', textAlign: 'center' }}>
                                    <div style={{ fontSize: '13px', color: '#666' }}>Expand to load lessons</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            {/* Footer */}
            <div style={{
              padding: '16px 24px',
              borderTop: '1px solid #e0e0e0',
              backgroundColor: '#f8f9fa',
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
              <button 
                onClick={handleCloseModulesModal}
                style={{
                  padding: '10px 24px',
                  backgroundColor: '#6c757d',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>

          <style>{`
            @keyframes slideInFromLeft {
              from {
                transform: translateX(-100%);
              }
              to {
                transform: translateX(0);
              }
            }
          `}</style>
        </>
      )}

      {showEnrollmentModal && (
        <div className="modal-overlay" onClick={handleCloseEnrollmentModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
            <div className="modal-header">
              <h2>Enroll Learner in Course</h2>
              <button className="modal-close" onClick={handleCloseEnrollmentModal}>×</button>
            </div>
            <div className="modal-body">
              <div className="form-section">
                <div className="form-group" style={{ position: 'relative' }}>
                  <label htmlFor="user_search">Search User *</label>
                  <input
                    type="text"
                    id="user_search"
                    value={userSearchQuery}
                    onChange={(e) => handleUserSearch(e.target.value)}
                    onFocus={() => userSearchResults.length > 0 && setShowUserDropdown(true)}
                    placeholder="Search by name or email..."
                    required
                    autoComplete="off"
                  />
                  {selectedUserName && (
                    <small style={{ color: '#28a745', fontSize: '12px', display: 'block', marginTop: '4px' }}>
                      ✓ Selected: {selectedUserName} (ID: {enrollmentFormData.user_id})
                    </small>
                  )}
                  {showUserDropdown && userSearchResults.length > 0 && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      maxHeight: '200px',
                      overflowY: 'auto',
                      backgroundColor: 'white',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      zIndex: 1000,
                      marginTop: '4px'
                    }}>
                      {userSearchResults.map(user => (
                        <div
                          key={user.id}
                          onClick={() => handleSelectUser(user)}
                          style={{
                            padding: '10px 12px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #f0f0f0',
                            ':hover': { backgroundColor: '#f5f5f5' }
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                        >
                          <div style={{ fontWeight: '500', color: '#333' }}>{user.full_name || 'No name'}</div>
                          <div style={{ fontSize: '12px', color: '#666' }}>{user.email}</div>
                          <div style={{ fontSize: '11px', color: '#999' }}>ID: {user.id}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="form-group" style={{ position: 'relative' }}>
                  <label htmlFor="course_search">Search Course *</label>
                  <input
                    type="text"
                    id="course_search"
                    value={courseSearchQuery}
                    onChange={(e) => handleCourseSearch(e.target.value)}
                    onFocus={() => courseSearchResults.length > 0 && setShowCourseDropdown(true)}
                    placeholder="Search by course code or title..."
                    required
                    autoComplete="off"
                  />
                  {selectedCourseName && (
                    <small style={{ color: '#28a745', fontSize: '12px', display: 'block', marginTop: '4px' }}>
                      ✓ Selected: {selectedCourseName} (ID: {enrollmentFormData.course_id})
                    </small>
                  )}
                  {showCourseDropdown && courseSearchResults.length > 0 && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      maxHeight: '200px',
                      overflowY: 'auto',
                      backgroundColor: 'white',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      zIndex: 1000,
                      marginTop: '4px'
                    }}>
                      {courseSearchResults.map(course => (
                        <div
                          key={course.id}
                          onClick={() => handleSelectCourse(course)}
                          style={{
                            padding: '10px 12px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #f0f0f0'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                        >
                          <div style={{ fontWeight: '500', color: '#333' }}>
                            {course.course_code} - {course.title}
                          </div>
                          <div style={{ fontSize: '11px', color: '#999' }}>ID: {course.id}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="form-row">
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="enrollment_source">Enrollment Source</label>
                    <select
                      id="enrollment_source"
                      value={enrollmentFormData.enrollment_source}
                      onChange={(e) => handleEnrollmentFormChange('enrollment_source', e.target.value)}
                    >
                      <option value="direct">Direct</option>
                      <option value="referral">Referral</option>
                      <option value="promotion">Promotion</option>
                    </select>
                  </div>

                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="status">Status</label>
                    <select
                      id="status"
                      value={enrollmentFormData.status}
                      onChange={(e) => handleEnrollmentFormChange('status', e.target.value)}
                    >
                      <option value="active">Active</option>
                      <option value="completed">Completed</option>
                      <option value="dropped">Dropped</option>
                      <option value="suspended">Suspended</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="payment_status">Payment Status</label>
                    <select
                      id="payment_status"
                      value={enrollmentFormData.payment_status}
                      onChange={(e) => handleEnrollmentFormChange('payment_status', e.target.value)}
                    >
                      <option value="free">Free</option>
                      <option value="paid">Paid</option>
                      <option value="pending">Pending</option>
                    </select>
                  </div>

                  <div className="form-group" style={{ flex: 1 }}>
                    <label htmlFor="payment_amount">Payment Amount ($)</label>
                    <input
                      type="number"
                      id="payment_amount"
                      value={enrollmentFormData.payment_amount}
                      onChange={(e) => handleEnrollmentFormChange('payment_amount', e.target.value)}
                      min="0"
                      step="0.01"
                      placeholder="0.00"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="notes">Notes</label>
                  <textarea
                    id="notes"
                    value={enrollmentFormData.notes}
                    onChange={(e) => handleEnrollmentFormChange('notes', e.target.value)}
                    placeholder="Add any additional notes..."
                    rows="3"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {/* Debug info */}
              <div style={{ padding: '8px', backgroundColor: '#f8f9fa', borderRadius: '4px', marginBottom: '12px', fontSize: '11px', fontFamily: 'monospace' }}>
                <div><strong>Debug Info:</strong></div>
                <div>User ID: {enrollmentFormData.user_id ? enrollmentFormData.user_id : '(not set)'}</div>
                <div>Course ID: {enrollmentFormData.course_id ? enrollmentFormData.course_id : '(not set)'}</div>
                <div>Button enabled: {(enrollmentFormData.user_id && enrollmentFormData.course_id) ? 'YES' : 'NO'}</div>
              </div>
              
              <button className="modal-btn modal-btn-cancel" onClick={handleCloseEnrollmentModal}>Cancel</button>
              <button 
                className="modal-btn modal-btn-confirm" 
                onClick={handleEnrollLearner}
                disabled={actionLoading === 'enroll-learner' || !(enrollmentFormData.user_id && enrollmentFormData.course_id)}
              >
                {actionLoading === 'enroll-learner' ? 'Enrolling...' : 'Enroll Learner'}
              </button>
              {!(enrollmentFormData.user_id && enrollmentFormData.course_id) && (
                <small style={{ color: '#dc3545', fontSize: '11px', marginTop: '8px', display: 'block', textAlign: 'center' }}>
                  Please select both user and course from the dropdown
                </small>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Admin;
